//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ConstructStartupUrl, STORAGE_KEY } from "../settings.service";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export abstract class RiderPortalServiceProxyBase {
    private startupBaseUrl: string | undefined = undefined;

    constructor() { }

    /**
     * Get the startup base url for this environment
     * @param url the default url the api was set up with.
     * @returns the default url
     */
    getBaseUrl(url: string): string {
        return ConstructStartupUrl(STORAGE_KEY) || url;
    }

    /**
     * This is a hack to allow us to override the base url. It's stupid and ugly.
     * @param url the url to override the baseUrl with
     */
    overrideBaseUrl(url: string): void {
        if ((this as any)?.baseUrl) (this as any).baseUrl = url;
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceProxy extends RiderPortalServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("/");
    }

    /**
     * Determines if the current user token is valid (Requires Bearer Token)
     * @return Success
     */
    loginCheckPOST(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/Authentication/login-check";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginCheckPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginCheckPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processLoginCheckPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determines if the current user token is valid (Requires Bearer Token)
     * @return Success
     */
    roleCheck(): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/Authentication/role-check";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoleCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoleCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRoleCheck(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Login for Portal Users (Delegate and Riders)
     * @param body (optional) 
     * @return Success
     */
    login(body: UserLoginModel | undefined): Observable<LoginResponseModel> {
        let url_ = this.baseUrl + "/api/v2/Authentication/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponseModel>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginResponseModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logs Out / Invalidates the Bearer Token
     * @return Success
     */
    logout(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/Authentication/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    configPOST(body: TransportationProviderSettingsRequest | undefined): Observable<TransportationProviderSettingsResponse> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransportationProviderSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransportationProviderSettingsResponse>;
        }));
    }

    protected processConfigPOST(response: HttpResponseBase): Observable<TransportationProviderSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransportationProviderSettingsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    configGET(transitAgencyId: string): Observable<TransportationProviderSettingsResponse> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/{transitAgencyId}/config";
        if (transitAgencyId === undefined || transitAgencyId === null)
            throw new Error("The parameter 'transitAgencyId' must be defined.");
        url_ = url_.replace("{transitAgencyId}", encodeURIComponent("" + transitAgencyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransportationProviderSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransportationProviderSettingsResponse>;
        }));
    }

    protected processConfigGET(response: HttpResponseBase): Observable<TransportationProviderSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransportationProviderSettingsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    loginCheckGET(): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/login-check";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginCheckGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginCheckGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLoginCheckGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List RIders Returns a list of delegate Riders for the logged in user
     * @return Success
     */
    tpListRiders(tpResourceId: string, searchString: string): Observable<VendorDelegateRider[]> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/{tpResourceId}/tp-list-riders/{searchString}";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTpListRiders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTpListRiders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDelegateRider[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDelegateRider[]>;
        }));
    }

    protected processTpListRiders(response: HttpResponseBase): Observable<VendorDelegateRider[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorDelegateRider[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a list of delegate Riders for the logged in user (who must be in the delegate role to access these API's)
     * @return Success
     */
    listRiders(searchString: string): Observable<VendorDelegateRider[]> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/list-riders/{searchString}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListRiders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListRiders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDelegateRider[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDelegateRider[]>;
        }));
    }

    protected processListRiders(response: HttpResponseBase): Observable<VendorDelegateRider[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorDelegateRider[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a list of the associated ride/Trip purposes for the logged in delegates trasportation provider (who must be in the delegate role to access these API's)
     * @return Success
     */
    listPurposes(): Observable<RideTripPurposes[]> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/list-purposes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListPurposes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPurposes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideTripPurposes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideTripPurposes[]>;
        }));
    }

    protected processListPurposes(response: HttpResponseBase): Observable<RideTripPurposes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideTripPurposes[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the Location History for a Delegates Requested Rides from the Vendor
     * @param newpassword (optional) 
     * @param newPasswordConfirm (optional) 
     * @return Success
     */
    delegateSetPassword(newpassword: string | undefined, newPasswordConfirm: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/delegate-set-password?";
        if (newpassword === null)
            throw new Error("The parameter 'newpassword' cannot be null.");
        else if (newpassword !== undefined)
            url_ += "newpassword=" + encodeURIComponent("" + newpassword) + "&";
        if (newPasswordConfirm === null)
            throw new Error("The parameter 'newPasswordConfirm' cannot be null.");
        else if (newPasswordConfirm !== undefined)
            url_ += "newPasswordConfirm=" + encodeURIComponent("" + newPasswordConfirm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelegateSetPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the Location History for a Delegates Requested Rides from the Vendor
     * @return Success
     */
    delegateRiderAddressHistory(vendorRiderId: string): Observable<AddressModel[]> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/delegate-rider-address-history/{vendorRiderId}";
        if (vendorRiderId === undefined || vendorRiderId === null)
            throw new Error("The parameter 'vendorRiderId' must be defined.");
        url_ = url_.replace("{vendorRiderId}", encodeURIComponent("" + vendorRiderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateRiderAddressHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateRiderAddressHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModel[]>;
        }));
    }

    protected processDelegateRiderAddressHistory(response: HttpResponseBase): Observable<AddressModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * return BadRequest("No data found!");Returns the Location History for a Delegates Requested Rides from the Vendor
     * @return Success
     */
    tpDelegateRiderAddressHistory(tpResourceId: string, vendorRiderId: string): Observable<AddressModel[]> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/{tpResourceId}/tp-delegate-rider-address-history/{vendorRiderId}";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        if (vendorRiderId === undefined || vendorRiderId === null)
            throw new Error("The parameter 'vendorRiderId' must be defined.");
        url_ = url_.replace("{vendorRiderId}", encodeURIComponent("" + vendorRiderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTpDelegateRiderAddressHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTpDelegateRiderAddressHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModel[]>;
        }));
    }

    protected processTpDelegateRiderAddressHistory(response: HttpResponseBase): Observable<AddressModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * **FOR TESTING: responseTest == Enum value to return valid values: Request a Ride for a Ride from the Delegate organization
     * @param body (optional) 
     * @return Success
     */
    delegateRequestRide(body: DelegateUserRideRequest | undefined): Observable<RequestRideResponse> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/delegate-request-ride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateRequestRide(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateRequestRide(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestRideResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestRideResponse>;
        }));
    }

    protected processDelegateRequestRide(response: HttpResponseBase): Observable<RequestRideResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestRideResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * **FOR TESTING: responseTest == Enum value to return valid values: Request a Ride for a Ride from the Delegate organization
     * @param body (optional) 
     * @return Success
     */
    tpDelegateRequestRide(tpDelegateOrganizationId: string, body: DelegateUserRideRequest | undefined): Observable<RequestRideResponse> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/{tpDelegateOrganizationId}/tp-delegate-request-ride";
        if (tpDelegateOrganizationId === undefined || tpDelegateOrganizationId === null)
            throw new Error("The parameter 'tpDelegateOrganizationId' must be defined.");
        url_ = url_.replace("{tpDelegateOrganizationId}", encodeURIComponent("" + tpDelegateOrganizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTpDelegateRequestRide(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTpDelegateRequestRide(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestRideResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestRideResponse>;
        }));
    }

    protected processTpDelegateRequestRide(response: HttpResponseBase): Observable<RequestRideResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestRideResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel a previously Requestd ride
     * @return Success
     */
    cancelDelegateRequestRide(rideRequestResourceId: string): Observable<CancelRideRequestResponse> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/cancel-delegate-request-ride/{rideRequestResourceId}";
        if (rideRequestResourceId === undefined || rideRequestResourceId === null)
            throw new Error("The parameter 'rideRequestResourceId' must be defined.");
        url_ = url_.replace("{rideRequestResourceId}", encodeURIComponent("" + rideRequestResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelDelegateRequestRide(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelDelegateRequestRide(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelRideRequestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelRideRequestResponse>;
        }));
    }

    protected processCancelDelegateRequestRide(response: HttpResponseBase): Observable<CancelRideRequestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CancelRideRequestResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a previously Requestd ride (NOT USED)
     * @param body (optional) 
     * @return Success
     */
    updateDelegateRequestRide(rideRequestResourceId: string, body: DelegateUserRideRequest | undefined): Observable<RequestRideResponse> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/update-delegate-request-ride/{rideRequestResourceId}";
        if (rideRequestResourceId === undefined || rideRequestResourceId === null)
            throw new Error("The parameter 'rideRequestResourceId' must be defined.");
        url_ = url_.replace("{rideRequestResourceId}", encodeURIComponent("" + rideRequestResourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDelegateRequestRide(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDelegateRequestRide(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestRideResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestRideResponse>;
        }));
    }

    protected processUpdateDelegateRequestRide(response: HttpResponseBase): Observable<RequestRideResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestRideResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    delegateRideDetails(rideResourceId: string): Observable<RideDetailsModel> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/delegate-ride-details/{rideResourceId}";
        if (rideResourceId === undefined || rideResourceId === null)
            throw new Error("The parameter 'rideResourceId' must be defined.");
        url_ = url_.replace("{rideResourceId}", encodeURIComponent("" + rideResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateRideDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateRideDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideDetailsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideDetailsModel>;
        }));
    }

    protected processDelegateRideDetails(response: HttpResponseBase): Observable<RideDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideDetailsModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets User Ride Ride History
     * @param body (optional) 
     * @return Success
     */
    listDelegateRideRequests(body: ListRidesRequest | undefined): Observable<RideList> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/list-delegate-ride-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDelegateRideRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDelegateRideRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideList>;
        }));
    }

    protected processListDelegateRideRequests(response: HttpResponseBase): Observable<RideList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param riderEmail (optional) 
     * @return Success
     */
    delegatePortalSettings(riderEmail: string | undefined): Observable<TripPortalSettings> {
        let url_ = this.baseUrl + "/api/v2/DelegateUser/delegate-portal-settings?";
        if (riderEmail === null)
            throw new Error("The parameter 'riderEmail' cannot be null.");
        else if (riderEmail !== undefined)
            url_ += "riderEmail=" + encodeURIComponent("" + riderEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatePortalSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatePortalSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TripPortalSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TripPortalSettings>;
        }));
    }

    protected processDelegatePortalSettings(response: HttpResponseBase): Observable<TripPortalSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TripPortalSettings;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    channelInfo(body: DeviceModel | undefined): Observable<DeviceChannelResponse> {
        let url_ = this.baseUrl + "/api/v2/Device/channel-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChannelInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChannelInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceChannelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceChannelResponse>;
        }));
    }

    protected processChannelInfo(response: HttpResponseBase): Observable<DeviceChannelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeviceChannelResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assign(body: PaymentAssignmentModel | undefined): Observable<VerifyResponseModel> {
        let url_ = this.baseUrl + "/api/v2/Payments/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerifyResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerifyResponseModel>;
        }));
    }

    protected processAssign(response: HttpResponseBase): Observable<VerifyResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VerifyResponseModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verify(body: VerifyPaymentMethodTokenModel | undefined): Observable<VerifyResponseModel> {
        let url_ = this.baseUrl + "/api/v2/Payments/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerifyResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerifyResponseModel>;
        }));
    }

    protected processVerify(response: HttpResponseBase): Observable<VerifyResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VerifyResponseModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    status(transportationProviderId: string, rideResourceId: string, body: RidePaymentStatusChangedModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/Payments/{transportationProviderId}/{rideResourceId}/status";
        if (transportationProviderId === undefined || transportationProviderId === null)
            throw new Error("The parameter 'transportationProviderId' must be defined.");
        url_ = url_.replace("{transportationProviderId}", encodeURIComponent("" + transportationProviderId));
        if (rideResourceId === undefined || rideResourceId === null)
            throw new Error("The parameter 'rideResourceId' must be defined.");
        url_ = url_.replace("{rideResourceId}", encodeURIComponent("" + rideResourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    configPOST2(body: TransportationProviderSettingsProviderRequest | undefined): Observable<TransportationProviderSettingsProviderResponse> {
        let url_ = this.baseUrl + "/api/v2/VoiceAgent/provider/transitAgencies/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigPOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigPOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransportationProviderSettingsProviderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransportationProviderSettingsProviderResponse>;
        }));
    }

    protected processConfigPOST2(response: HttpResponseBase): Observable<TransportationProviderSettingsProviderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransportationProviderSettingsProviderResponse;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    configGET2(externalId: string): Observable<TransportationProviderSettingsProviderResponse> {
        let url_ = this.baseUrl + "/api/v2/VoiceAgent/provider/transitAgencies/{externalId}/config";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransportationProviderSettingsProviderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransportationProviderSettingsProviderResponse>;
        }));
    }

    protected processConfigGET2(response: HttpResponseBase): Observable<TransportationProviderSettingsProviderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransportationProviderSettingsProviderResponse;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * New Account (Non-Delegate) Rider, Email is sent and must be confirmed
     * @param body (optional) 
     * @return Success
     */
    newAccount(body: UserRegistrationModel | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/registration/new-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processNewAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the current user object.
     * @return Success
     */
    userProfile(): Observable<UserProfile> {
        let url_ = this.baseUrl + "/api/v2/registration/user-profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfile>;
        }));
    }

    protected processUserProfile(response: HttpResponseBase): Observable<UserProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfile;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Email will contain a link which will direct the user here, if successful (200 ok / true response), the user should be direct to set their password.
     * @param userId (optional) 
     * @param code (optional) 
     * @param providerCode (optional) 
     * @return Success
     */
    emailVerification(userId: string | undefined, code: string | undefined, providerCode: string | undefined): Observable<LoginResponseModel> {
        let url_ = this.baseUrl + "/api/v2/registration/email-verification?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (providerCode === null)
            throw new Error("The parameter 'providerCode' cannot be null.");
        else if (providerCode !== undefined)
            url_ += "providerCode=" + encodeURIComponent("" + providerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponseModel>;
        }));
    }

    protected processEmailVerification(response: HttpResponseBase): Observable<LoginResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginResponseModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resend the email verification. if this was a delegate organization invitation, the provider code must be provided
     * @param userId (optional) 
     * @param providerCode (optional) 
     * @return Success
     */
    resendEmailVerification(userId: string | undefined, providerCode: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/registration/resend-email-verification?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (providerCode === null)
            throw new Error("The parameter 'providerCode' cannot be null.");
        else if (providerCode !== undefined)
            url_ += "providerCode=" + encodeURIComponent("" + providerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendEmailVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendEmailVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResendEmailVerification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiate the forgot password request, it will send an email with the forgot password
     * @param userEmail (optional) 
     * @return Success
     */
    forgotPassword(userEmail: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/registration/forgot-password?";
        if (userEmail === null)
            throw new Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset Password Confirmatin / Validation (NOT SURE)
     * @param userId (optional) 
     * @param code (optional) 
     * @return Success
     */
    forgotPasswordConfirm(userId: string | undefined, code: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/registration/forgot-password-confirm?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPasswordConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPasswordConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForgotPasswordConfirm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset the User Portal Password
     * @param userId (optional) 
     * @param code (optional) 
     * @param body (optional) 
     * @return Success
     */
    forgotPasswordChange(userId: string | undefined, code: string | undefined, body: UserChangePasswordModel | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/registration/forgot-password-change?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPasswordChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPasswordChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForgotPasswordChange(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Request the Details of the Ride, if requesting a ride from the
     * @param body (optional) 
     * @return Success
     */
    requestRide(body: RideRequest | undefined): Observable<RequestRideResponse> {
        let url_ = this.baseUrl + "/api/v2/Rider/request-ride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestRide(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestRide(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestRideResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestRideResponse>;
        }));
    }

    protected processRequestRide(response: HttpResponseBase): Observable<RequestRideResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestRideResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestRides(body: RidePaymentRequest | undefined): Observable<RequestRideResponse[]> {
        let url_ = this.baseUrl + "/api/v2/Rider/request-rides";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestRides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestRides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestRideResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestRideResponse[]>;
        }));
    }

    protected processRequestRides(response: HttpResponseBase): Observable<RequestRideResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestRideResponse[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Request the Details of the Ride, if requesting a ride from the
     * @param body (optional) 
     * @return Success
     */
    updateRequestRide(rideRequestResourceId: string, body: RideRequest | undefined): Observable<RequestRideResponse> {
        let url_ = this.baseUrl + "/api/v2/Rider/update-request-ride/{rideRequestResourceId}";
        if (rideRequestResourceId === undefined || rideRequestResourceId === null)
            throw new Error("The parameter 'rideRequestResourceId' must be defined.");
        url_ = url_.replace("{rideRequestResourceId}", encodeURIComponent("" + rideRequestResourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRequestRide(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRequestRide(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestRideResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestRideResponse>;
        }));
    }

    protected processUpdateRequestRide(response: HttpResponseBase): Observable<RequestRideResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestRideResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel a previously Requestd ride
     * @return Success
     */
    cancelRequestRide(rideRequestResourceId: string): Observable<CancelRideRequestResponse> {
        let url_ = this.baseUrl + "/api/v2/Rider/cancel-request-ride/{rideRequestResourceId}";
        if (rideRequestResourceId === undefined || rideRequestResourceId === null)
            throw new Error("The parameter 'rideRequestResourceId' must be defined.");
        url_ = url_.replace("{rideRequestResourceId}", encodeURIComponent("" + rideRequestResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRequestRide(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRequestRide(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelRideRequestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelRideRequestResponse>;
        }));
    }

    protected processCancelRequestRide(response: HttpResponseBase): Observable<CancelRideRequestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CancelRideRequestResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Logged In Users Ride Ride History
     * @param body (optional) 
     * @return Success
     */
    listRiderRideRequests(body: ListRidesRequest | undefined): Observable<RideList> {
        let url_ = this.baseUrl + "/api/v2/Rider/list-rider-ride-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListRiderRideRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListRiderRideRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideList>;
        }));
    }

    protected processListRiderRideRequests(response: HttpResponseBase): Observable<RideList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    rideDetails(rideResourceId: string): Observable<RideDetailsModel> {
        let url_ = this.baseUrl + "/api/v2/Rider/ride-details/{rideResourceId}";
        if (rideResourceId === undefined || rideResourceId === null)
            throw new Error("The parameter 'rideResourceId' must be defined.");
        url_ = url_.replace("{rideResourceId}", encodeURIComponent("" + rideResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRideDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRideDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideDetailsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideDetailsModel>;
        }));
    }

    protected processRideDetails(response: HttpResponseBase): Observable<RideDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideDetailsModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks the Return Ride Ready (TBD)
     * @return Success
     * @deprecated
     */
    rideReturnReady(rideResourceId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/Rider/ride-return-ready/{rideResourceId}";
        if (rideResourceId === undefined || rideResourceId === null)
            throw new Error("The parameter 'rideResourceId' must be defined.");
        url_ = url_.replace("{rideResourceId}", encodeURIComponent("" + rideResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRideReturnReady(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRideReturnReady(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRideReturnReady(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Logged In Users Ride's ready for payment
     * @return Success
     */
    listRequestsPendingPayment(): Observable<RideList> {
        let url_ = this.baseUrl + "/api/v2/Rider/list-requests-pending-payment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListRequestsPendingPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListRequestsPendingPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideList>;
        }));
    }

    protected processListRequestsPendingPayment(response: HttpResponseBase): Observable<RideList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Locks out a user essentially disabling their account
     * @return Success
     */
    lockoutUser(): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/Rider/lockout-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockoutUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockoutUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLockoutUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the Location History for a Delegates Requested Rides from the Vendor
     * @param newpassword (optional) 
     * @param newPasswordConfirm (optional) 
     * @return Success
     */
    setPassword(newpassword: string | undefined, newPasswordConfirm: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/Rider/set-password?";
        if (newpassword === null)
            throw new Error("The parameter 'newpassword' cannot be null.");
        else if (newpassword !== undefined)
            url_ += "newpassword=" + encodeURIComponent("" + newpassword) + "&";
        if (newPasswordConfirm === null)
            throw new Error("The parameter 'newPasswordConfirm' cannot be null.");
        else if (newPasswordConfirm !== undefined)
            url_ += "newPasswordConfirm=" + encodeURIComponent("" + newPasswordConfirm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param riderEmail (optional) 
     * @return Success
     */
    portalSettings(riderEmail: string | undefined): Observable<TripPortalSettings> {
        let url_ = this.baseUrl + "/api/v2/Rider/portal-settings?";
        if (riderEmail === null)
            throw new Error("The parameter 'riderEmail' cannot be null.");
        else if (riderEmail !== undefined)
            url_ += "riderEmail=" + encodeURIComponent("" + riderEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPortalSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPortalSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TripPortalSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TripPortalSettings>;
        }));
    }

    protected processPortalSettings(response: HttpResponseBase): Observable<TripPortalSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TripPortalSettings;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    location(body: Coordinate[] | undefined): Observable<TripPortalSettings> {
        let url_ = this.baseUrl + "/api/v2/Rider/portal-settings/location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TripPortalSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TripPortalSettings>;
        }));
    }

    protected processLocation(response: HttpResponseBase): Observable<TripPortalSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TripPortalSettings;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fare(portalUserResourceId: string, transportationProviderResourceId: string, body: RideRequest[] | undefined): Observable<RideRequestFareResponse[]> {
        let url_ = this.baseUrl + "/api/v2/Rider/{portalUserResourceId}/fare/{transportationProviderResourceId}";
        if (portalUserResourceId === undefined || portalUserResourceId === null)
            throw new Error("The parameter 'portalUserResourceId' must be defined.");
        url_ = url_.replace("{portalUserResourceId}", encodeURIComponent("" + portalUserResourceId));
        if (transportationProviderResourceId === undefined || transportationProviderResourceId === null)
            throw new Error("The parameter 'transportationProviderResourceId' must be defined.");
        url_ = url_.replace("{transportationProviderResourceId}", encodeURIComponent("" + transportationProviderResourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideRequestFareResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideRequestFareResponse[]>;
        }));
    }

    protected processFare(response: HttpResponseBase): Observable<RideRequestFareResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideRequestFareResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends a message to the Dispatcher
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    sendMessage(body: RideMessage | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/Rider/send-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendMessage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the Location History for a Delegates Requested Rides from the Vendor
     * @return Success
     */
    addressHistory(): Observable<AddressModel[]> {
        let url_ = this.baseUrl + "/api/v2/RiderAddress/address-history";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModel[]>;
        }));
    }

    protected processAddressHistory(response: HttpResponseBase): Observable<AddressModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the Location History for a Delegates Requested Rides from the Vendor
     * @return Success
     */
    addressFavorites(): Observable<AddressModel[]> {
        let url_ = this.baseUrl + "/api/v2/RiderAddress/address-favorites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModel[]>;
        }));
    }

    protected processAddressFavorites(response: HttpResponseBase): Observable<AddressModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the Location History for a Delegates Requested Rides from the Vendor
     * @return Success
     */
    addAddressFavorite(addressResourceId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/RiderAddress/add-address-favorite/{AddressResourceId}";
        if (addressResourceId === undefined || addressResourceId === null)
            throw new Error("The parameter 'addressResourceId' must be defined.");
        url_ = url_.replace("{AddressResourceId}", encodeURIComponent("" + addressResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAddressFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAddressFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddAddressFavorite(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the Location History for a Delegates Requested Rides from the Vendor
     * @return Success
     */
    removeAddressFavorite(addressResourceId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/RiderAddress/remove-address-favorite/{AddressResourceId}";
        if (addressResourceId === undefined || addressResourceId === null)
            throw new Error("The parameter 'addressResourceId' must be defined.");
        url_ = url_.replace("{AddressResourceId}", encodeURIComponent("" + addressResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAddressFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAddressFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemoveAddressFavorite(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tpResourceId (optional) 
     * @param daysFromToday (optional) 
     * @return Success
     */
    vendorTpPendingRides(tpResourceId: string | undefined, daysFromToday: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/rider/vendor-tp-pending-rides?";
        if (tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' cannot be null.");
        else if (tpResourceId !== undefined)
            url_ += "tpResourceId=" + encodeURIComponent("" + tpResourceId) + "&";
        if (daysFromToday === null)
            throw new Error("The parameter 'daysFromToday' cannot be null.");
        else if (daysFromToday !== undefined)
            url_ += "daysFromToday=" + encodeURIComponent("" + daysFromToday) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVendorTpPendingRides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVendorTpPendingRides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVendorTpPendingRides(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    genderTypes(): Observable<GenderType[]> {
        let url_ = this.baseUrl + "/api/v2/rider/gender-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenderTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenderTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenderType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenderType[]>;
        }));
    }

    protected processGenderTypes(response: HttpResponseBase): Observable<GenderType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenderType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    rideRequirementTypes(): Observable<RideRequirementType[]> {
        let url_ = this.baseUrl + "/api/v2/rider/ride-requirement-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRideRequirementTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRideRequirementTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideRequirementType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideRequirementType[]>;
        }));
    }

    protected processRideRequirementTypes(response: HttpResponseBase): Observable<RideRequirementType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideRequirementType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    rideReservationTypes(): Observable<RideReservationType[]> {
        let url_ = this.baseUrl + "/api/v2/rider/ride-reservation-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRideReservationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRideReservationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideReservationType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideReservationType[]>;
        }));
    }

    protected processRideReservationTypes(response: HttpResponseBase): Observable<RideReservationType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideReservationType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    rideStatusTypes(): Observable<RideStatusType[]> {
        let url_ = this.baseUrl + "/api/v2/rider/ride-status-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRideStatusTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRideStatusTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideStatusType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideStatusType[]>;
        }));
    }

    protected processRideStatusTypes(response: HttpResponseBase): Observable<RideStatusType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideStatusType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTransportationProvider(body: VendorTransportationProvider | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/vendor/create-transportation-provider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransportationProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransportationProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateTransportationProvider(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTransportationProvider(resourceId: string, body: VendorTransportationProvider | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/update-transportation-provider/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransportationProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransportationProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTransportationProvider(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDelegate(delegateOrgResourceId: string, body: VendorDelegateUser | undefined): Observable<CreateDelegateUserResponse> {
        let url_ = this.baseUrl + "/api/v2/vendor/{delegateOrgResourceId}/create-delegate";
        if (delegateOrgResourceId === undefined || delegateOrgResourceId === null)
            throw new Error("The parameter 'delegateOrgResourceId' must be defined.");
        url_ = url_.replace("{delegateOrgResourceId}", encodeURIComponent("" + delegateOrgResourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDelegate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDelegate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDelegateUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDelegateUserResponse>;
        }));
    }

    protected processCreateDelegate(response: HttpResponseBase): Observable<CreateDelegateUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateDelegateUserResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDelegate(resourceId: string, body: VendorDelegateUser | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/update-delegate/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDelegate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDelegate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateDelegate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDelegate(resourceId: string): Observable<VendorDelegateUser> {
        let url_ = this.baseUrl + "/api/v2/vendor/get-delegate/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDelegateUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDelegateUser>;
        }));
    }

    protected processGetDelegate(response: HttpResponseBase): Observable<VendorDelegateUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorDelegateUser;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDelegateOrg(tpResourceId: string, body: VendorDelegateOrganization | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/vendor/{tpResourceId}/create-delegate-org";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDelegateOrg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDelegateOrg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateDelegateOrg(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDelegateOrg(resourceId: string, body: VendorDelegateOrganization | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/update-delegate-org/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDelegateOrg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDelegateOrg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateDelegateOrg(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDelegateOrg(resourceId: string): Observable<VendorDelegateOrganization> {
        let url_ = this.baseUrl + "/api/v2/vendor/get-delegate-org/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegateOrg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegateOrg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDelegateOrganization>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDelegateOrganization>;
        }));
    }

    protected processGetDelegateOrg(response: HttpResponseBase): Observable<VendorDelegateOrganization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorDelegateOrganization;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    vendorTpEmailAvailable(tpResourceId: string, emailAddress: string): Observable<EmailAccountDetails> {
        let url_ = this.baseUrl + "/api/v2/vendor/vendor-tp-email-available/{tpResourceId}/{emailAddress}";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        if (emailAddress === undefined || emailAddress === null)
            throw new Error("The parameter 'emailAddress' must be defined.");
        url_ = url_.replace("{emailAddress}", encodeURIComponent("" + emailAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVendorTpEmailAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVendorTpEmailAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAccountDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAccountDetails>;
        }));
    }

    protected processVendorTpEmailAvailable(response: HttpResponseBase): Observable<EmailAccountDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailAccountDetails;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPortaluser(tpResourceId: string, body: VendorPortalUser | undefined): Observable<VendorApiResponse> {
        let url_ = this.baseUrl + "/api/v2/vendor/{tpResourceId}/create-portaluser";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePortaluser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePortaluser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorApiResponse>;
        }));
    }

    protected processCreatePortaluser(response: HttpResponseBase): Observable<VendorApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorApiResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePortaluser(portalUserResourceId: string, body: VendorPortalUser | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/{portalUserResourceId}/update-portaluser";
        if (portalUserResourceId === undefined || portalUserResourceId === null)
            throw new Error("The parameter 'portalUserResourceId' must be defined.");
        url_ = url_.replace("{portalUserResourceId}", encodeURIComponent("" + portalUserResourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePortaluser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePortaluser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdatePortaluser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    disableTpPortaluser(tpResourceId: string, portalUserResourceId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/{tpResourceId}/{portalUserResourceId}/disable-tp-portaluser";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        if (portalUserResourceId === undefined || portalUserResourceId === null)
            throw new Error("The parameter 'portalUserResourceId' must be defined.");
        url_ = url_.replace("{portalUserResourceId}", encodeURIComponent("" + portalUserResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableTpPortaluser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableTpPortaluser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisableTpPortaluser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    enableTpPortaluser(tpResourceId: string, portalUserResourceId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/{tpResourceId}/{portalUserResourceId}/enable-tp-portaluser";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        if (portalUserResourceId === undefined || portalUserResourceId === null)
            throw new Error("The parameter 'portalUserResourceId' must be defined.");
        url_ = url_.replace("{portalUserResourceId}", encodeURIComponent("" + portalUserResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableTpPortaluser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableTpPortaluser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEnableTpPortaluser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resend the delegate email verification. provider code must be provided
     * @return Success
     */
    resendDelegateEmailVerification(transportationProviderResourceId: string, portalUserResourceId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/resend-delegate-email-verification/{transportationProviderResourceId}/{portalUserResourceId}";
        if (transportationProviderResourceId === undefined || transportationProviderResourceId === null)
            throw new Error("The parameter 'transportationProviderResourceId' must be defined.");
        url_ = url_.replace("{transportationProviderResourceId}", encodeURIComponent("" + transportationProviderResourceId));
        if (portalUserResourceId === undefined || portalUserResourceId === null)
            throw new Error("The parameter 'portalUserResourceId' must be defined.");
        url_ = url_.replace("{portalUserResourceId}", encodeURIComponent("" + portalUserResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendDelegateEmailVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendDelegateEmailVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResendDelegateEmailVerification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resend the delegate invite email.
     * @return Success
     */
    resendDelegateInvite(transportationProviderResourceId: string, portalUserResourceId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/resend-delegate-invite/{transportationProviderResourceId}/{portalUserResourceId}";
        if (transportationProviderResourceId === undefined || transportationProviderResourceId === null)
            throw new Error("The parameter 'transportationProviderResourceId' must be defined.");
        url_ = url_.replace("{transportationProviderResourceId}", encodeURIComponent("" + transportationProviderResourceId));
        if (portalUserResourceId === undefined || portalUserResourceId === null)
            throw new Error("The parameter 'portalUserResourceId' must be defined.");
        url_ = url_.replace("{portalUserResourceId}", encodeURIComponent("" + portalUserResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendDelegateInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendDelegateInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResendDelegateInvite(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param min (optional) 
     * @param max (optional) 
     * @return Success
     */
    pendingRides(tpResourceId: string, min: Date | undefined, max: Date | undefined): Observable<VendorDelegateRideRequest[]> {
        let url_ = this.baseUrl + "/api/v2/vendor/{tpResourceId}/pending-rides?";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        if (min === null)
            throw new Error("The parameter 'min' cannot be null.");
        else if (min !== undefined)
            url_ += "min=" + encodeURIComponent(min ? "" + min.toISOString() : "") + "&";
        if (max === null)
            throw new Error("The parameter 'max' cannot be null.");
        else if (max !== undefined)
            url_ += "max=" + encodeURIComponent(max ? "" + max.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendingRides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendingRides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDelegateRideRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDelegateRideRequest[]>;
        }));
    }

    protected processPendingRides(response: HttpResponseBase): Observable<VendorDelegateRideRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorDelegateRideRequest[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRideStatus(tpRideResourceId: string, body: RideStatusUpdate | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/update-ride-status/{tpRideResourceId}";
        if (tpRideResourceId === undefined || tpRideResourceId === null)
            throw new Error("The parameter 'tpRideResourceId' must be defined.");
        url_ = url_.replace("{tpRideResourceId}", encodeURIComponent("" + tpRideResourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRideStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRideStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateRideStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    cancelRideRequest(tpRideResourceId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/cancel-ride-request/{tpRideResourceId}";
        if (tpRideResourceId === undefined || tpRideResourceId === null)
            throw new Error("The parameter 'tpRideResourceId' must be defined.");
        url_ = url_.replace("{tpRideResourceId}", encodeURIComponent("" + tpRideResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRideRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRideRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancelRideRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    rideDetails2(tpResourceId: string, tpRideResourceId: string): Observable<VendorDelegateRideRequest> {
        let url_ = this.baseUrl + "/api/v2/vendor/{tpResourceId}/ride-details/{tpRideResourceId}";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        if (tpRideResourceId === undefined || tpRideResourceId === null)
            throw new Error("The parameter 'tpRideResourceId' must be defined.");
        url_ = url_.replace("{tpRideResourceId}", encodeURIComponent("" + tpRideResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRideDetails2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRideDetails2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDelegateRideRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDelegateRideRequest>;
        }));
    }

    protected processRideDetails2(response: HttpResponseBase): Observable<VendorDelegateRideRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorDelegateRideRequest;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    blockRider(tpResourceId: string, portalUserResourceId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/vendor/{tpResourceId}/block-rider/{portalUserResourceId}";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        if (portalUserResourceId === undefined || portalUserResourceId === null)
            throw new Error("The parameter 'portalUserResourceId' must be defined.");
        url_ = url_.replace("{portalUserResourceId}", encodeURIComponent("" + portalUserResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockRider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockRider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBlockRider(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    summary(tpResourceId: string, portalUserResourceId: string): Observable<VendorPortalUserSummary> {
        let url_ = this.baseUrl + "/api/v2/vendor/{tpResourceId}/portaluser/{portalUserResourceId}/summary";
        if (tpResourceId === undefined || tpResourceId === null)
            throw new Error("The parameter 'tpResourceId' must be defined.");
        url_ = url_.replace("{tpResourceId}", encodeURIComponent("" + tpResourceId));
        if (portalUserResourceId === undefined || portalUserResourceId === null)
            throw new Error("The parameter 'portalUserResourceId' must be defined.");
        url_ = url_.replace("{portalUserResourceId}", encodeURIComponent("" + portalUserResourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorPortalUserSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorPortalUserSummary>;
        }));
    }

    protected processSummary(response: HttpResponseBase): Observable<VendorPortalUserSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorPortalUserSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param portalUserResourceIdString (optional) 
     * @param emailAddress (optional) 
     * @param body (optional) 
     * @return Success
     */
    inviteToPortal(tpResourceIdString: string, portalUserResourceIdString: string | undefined, emailAddress: string | undefined, body: Rider | undefined): Observable<VendorApiResponse> {
        let url_ = this.baseUrl + "/api/v2/vendor/{tpResourceIdString}/invite-to-portal?";
        if (tpResourceIdString === undefined || tpResourceIdString === null)
            throw new Error("The parameter 'tpResourceIdString' must be defined.");
        url_ = url_.replace("{tpResourceIdString}", encodeURIComponent("" + tpResourceIdString));
        if (portalUserResourceIdString === null)
            throw new Error("The parameter 'portalUserResourceIdString' cannot be null.");
        else if (portalUserResourceIdString !== undefined)
            url_ += "portalUserResourceIdString=" + encodeURIComponent("" + portalUserResourceIdString) + "&";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteToPortal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteToPortal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorApiResponse>;
        }));
    }

    protected processInviteToPortal(response: HttpResponseBase): Observable<VendorApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorApiResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of rides for a specified rider within a given date range.
     * @param riderId The unique identifier of the rider. This parameter is required and must be a valid string.
     * @param start (optional) The start of the date range for which to retrieve rides. If not provided or invalid, defaults to one day prior to
                the current date.
     * @param end (optional) The end of the date range for which to retrieve rides. If not provided or invalid, defaults to three days after
                the current date.
     * @return Success
     */
    riders(riderId: string, start: Date | undefined, end: Date | undefined): Observable<VoiceAgentVendorRideRequest[]> {
        let url_ = this.baseUrl + "/api/v2/vendor/transitAgencies/riders/{riderId}?";
        if (riderId === undefined || riderId === null)
            throw new Error("The parameter 'riderId' must be defined.");
        url_ = url_.replace("{riderId}", encodeURIComponent("" + riderId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRiders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRiders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoiceAgentVendorRideRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoiceAgentVendorRideRequest[]>;
        }));
    }

    protected processRiders(response: HttpResponseBase): Observable<VoiceAgentVendorRideRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoiceAgentVendorRideRequest[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of rides for a specified rider within a given date range.
     * @param riderId The unique identifier of the rider. This parameter is required and must be a valid string.
     * @param start (optional) The start of the date range for which to retrieve rides. If not provided or invalid, defaults to one day prior to
                the current date.
     * @param end (optional) The end of the date range for which to retrieve rides. If not provided or invalid, defaults to three days after
                the current date.
     * @return Success
     */
    delegateriders(riderId: string, start: Date | undefined, end: Date | undefined): Observable<VoiceAgentVendorRideRequest[]> {
        let url_ = this.baseUrl + "/api/v2/vendor/transitAgencies/delegateriders/{riderId}?";
        if (riderId === undefined || riderId === null)
            throw new Error("The parameter 'riderId' must be defined.");
        url_ = url_.replace("{riderId}", encodeURIComponent("" + riderId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateriders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateriders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoiceAgentVendorRideRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoiceAgentVendorRideRequest[]>;
        }));
    }

    protected processDelegateriders(response: HttpResponseBase): Observable<VoiceAgentVendorRideRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoiceAgentVendorRideRequest[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancels a ride associated with the specified ride identifier.
     * @param rideId The unique identifier of the ride to be canceled. This value is required to locate the specific ride.
     * @return Success
     */
    cancel(rideId: string): Observable<CancelRideRequestResponse> {
        let url_ = this.baseUrl + "/api/v2/vendor/transitAgencies/rides/{rideId}/cancel";
        if (rideId === undefined || rideId === null)
            throw new Error("The parameter 'rideId' must be defined.");
        url_ = url_.replace("{rideId}", encodeURIComponent("" + rideId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelRideRequestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelRideRequestResponse>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<CancelRideRequestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CancelRideRequestResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the estimated time of arrival (ETA) for a specific ride.
     * @param rideId The unique identifier of the ride for which the ETA is requested.
     * @return Success
     */
    eta(rideId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/vendor/transitAgencies/rides/{rideId}/eta";
        if (rideId === undefined || rideId === null)
            throw new Error("The parameter 'rideId' must be defined.");
        url_ = url_.replace("{rideId}", encodeURIComponent("" + rideId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEta(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param phoneNumber (optional) 
     * @param dateOfBirth (optional) 
     * @param email (optional) 
     * @param homeZipCode (optional) 
     * @return Success
     */
    identify(transitAgencyId: string, firstName: string | undefined, lastName: string | undefined, phoneNumber: string | undefined, dateOfBirth: string | undefined, email: string | undefined, homeZipCode: string | undefined): Observable<RiderSearchResponse> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/{transitAgencyId}/caller/identify?";
        if (transitAgencyId === undefined || transitAgencyId === null)
            throw new Error("The parameter 'transitAgencyId' must be defined.");
        url_ = url_.replace("{transitAgencyId}", encodeURIComponent("" + transitAgencyId));
        if (firstName === null)
            throw new Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (dateOfBirth === null)
            throw new Error("The parameter 'dateOfBirth' cannot be null.");
        else if (dateOfBirth !== undefined)
            url_ += "dateOfBirth=" + encodeURIComponent("" + dateOfBirth) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (homeZipCode === null)
            throw new Error("The parameter 'homeZipCode' cannot be null.");
        else if (homeZipCode !== undefined)
            url_ += "homeZipCode=" + encodeURIComponent("" + homeZipCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIdentify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIdentify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiderSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiderSearchResponse>;
        }));
    }

    protected processIdentify(response: HttpResponseBase): Observable<RiderSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RiderSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rides(transitAgencyId: string, body: CreateRideRequest | undefined): Observable<RideCreateResponse> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/{transitAgencyId}/rides";
        if (transitAgencyId === undefined || transitAgencyId === null)
            throw new Error("The parameter 'transitAgencyId' must be defined.");
        url_ = url_.replace("{transitAgencyId}", encodeURIComponent("" + transitAgencyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideCreateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideCreateResponse>;
        }));
    }

    protected processRides(response: HttpResponseBase): Observable<RideCreateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideCreateResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideCreateResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    addresses(transitAgencyId: string, riderId: string): Observable<AddressListResponse> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/{transitAgencyId}/riders/{riderId}/addresses";
        if (transitAgencyId === undefined || transitAgencyId === null)
            throw new Error("The parameter 'transitAgencyId' must be defined.");
        url_ = url_.replace("{transitAgencyId}", encodeURIComponent("" + transitAgencyId));
        if (riderId === undefined || riderId === null)
            throw new Error("The parameter 'riderId' must be defined.");
        url_ = url_.replace("{riderId}", encodeURIComponent("" + riderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddresses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressListResponse>;
        }));
    }

    protected processAddresses(response: HttpResponseBase): Observable<AddressListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressListResponse;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @return Success
     * @deprecated
     */
    riders2(transitAgencyId: string, riderId: string, start: Date | undefined, end: Date | undefined): Observable<RideResponse[]> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/{transitAgencyId}/riders/{riderId}?";
        if (transitAgencyId === undefined || transitAgencyId === null)
            throw new Error("The parameter 'transitAgencyId' must be defined.");
        url_ = url_.replace("{transitAgencyId}", encodeURIComponent("" + transitAgencyId));
        if (riderId === undefined || riderId === null)
            throw new Error("The parameter 'riderId' must be defined.");
        url_ = url_.replace("{riderId}", encodeURIComponent("" + riderId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRiders2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRiders2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideResponse[]>;
        }));
    }

    protected processRiders2(response: HttpResponseBase): Observable<RideResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @return Success
     */
    ridesAll(transitAgencyId: string, riderId: string, start: Date | undefined, end: Date | undefined): Observable<RideResponse[]> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/{transitAgencyId}/riders/{riderId}/rides?";
        if (transitAgencyId === undefined || transitAgencyId === null)
            throw new Error("The parameter 'transitAgencyId' must be defined.");
        url_ = url_.replace("{transitAgencyId}", encodeURIComponent("" + transitAgencyId));
        if (riderId === undefined || riderId === null)
            throw new Error("The parameter 'riderId' must be defined.");
        url_ = url_.replace("{riderId}", encodeURIComponent("" + riderId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRidesAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRidesAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideResponse[]>;
        }));
    }

    protected processRidesAll(response: HttpResponseBase): Observable<RideResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    cancelAll(transitAgencyId: string, rideId: string): Observable<RideResponse[]> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/{transitAgencyId}/rides/{rideId}/cancel";
        if (transitAgencyId === undefined || transitAgencyId === null)
            throw new Error("The parameter 'transitAgencyId' must be defined.");
        url_ = url_.replace("{transitAgencyId}", encodeURIComponent("" + transitAgencyId));
        if (rideId === undefined || rideId === null)
            throw new Error("The parameter 'rideId' must be defined.");
        url_ = url_.replace("{rideId}", encodeURIComponent("" + rideId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideResponse[]>;
        }));
    }

    protected processCancelAll(response: HttpResponseBase): Observable<RideResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    etaAll(transitAgencyId: string, rideId: string): Observable<RideResponse[]> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/{transitAgencyId}/rides/{rideId}/eta";
        if (transitAgencyId === undefined || transitAgencyId === null)
            throw new Error("The parameter 'transitAgencyId' must be defined.");
        url_ = url_.replace("{transitAgencyId}", encodeURIComponent("" + transitAgencyId));
        if (rideId === undefined || rideId === null)
            throw new Error("The parameter 'rideId' must be defined.");
        url_ = url_.replace("{rideId}", encodeURIComponent("" + rideId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEtaAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEtaAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RideResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RideResponse[]>;
        }));
    }

    protected processEtaAll(response: HttpResponseBase): Observable<RideResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RideResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ready(transitAgencyId: string, rideId: string): Observable<WillCallReadyResponse> {
        let url_ = this.baseUrl + "/api/v2/VoiceAssistant/transitAgencies/{transitAgencyId}/rides/{rideId}/willcall/ready";
        if (transitAgencyId === undefined || transitAgencyId === null)
            throw new Error("The parameter 'transitAgencyId' must be defined.");
        url_ = url_.replace("{transitAgencyId}", encodeURIComponent("" + transitAgencyId));
        if (rideId === undefined || rideId === null)
            throw new Error("The parameter 'rideId' must be defined.");
        url_ = url_.replace("{rideId}", encodeURIComponent("" + rideId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReady(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReady(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WillCallReadyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WillCallReadyResponse>;
        }));
    }

    protected processReady(response: HttpResponseBase): Observable<WillCallReadyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WillCallReadyResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface Account {
    billingMethodDetails: AccountBillMethod;
    accountId: number;
    billingMethodId: number | undefined;
    agencyId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    minimumMiles: number | undefined;
    maximumMiles: number | undefined;
    hourlyWaitRate: number | undefined;
    wheelchairRate: number | undefined;
    escortRate: number | undefined;
    extraCharge: number | undefined;
    minimumCharge: number | undefined;
    maximumCharge: number | undefined;
    noShowExtra: number;
    hourlyRate: number | undefined;
    rate: number | undefined;
    mileageRate: number | undefined;
    billNoShow: boolean | undefined;
    idNumber: string | undefined;
    decimals: number | undefined;
    dbstatus: number;
    canAssignManually: boolean | undefined;
    stretcherRate: number;
    requireAuthorizationNumber: boolean;
    transportationMode: string | undefined;
    allowRideChargeAdjustment: boolean;
    billEscortAsPassenger: boolean;
    scheduleProfileId: number | undefined;
    signatureRequired: boolean;
    useDirectMileageForPassPlus: boolean;
    serviceType: number;
    baseRate: number | undefined;
    perMileRevenue: number | undefined;
    rideAlertProviderId: number | undefined;
    canBillEmptyMiles: boolean | undefined;
    brokerAccountIdList: string | undefined;
    agency: Agency;
    rideAlertProvider: RideAlertProvider;
    scheduleProfile: ScheduleProfile;
    accountCharges: AccountCharge[] | undefined;
    companyLcAccounts: Company[] | undefined;
    brokerContracts: BrokerContract[] | undefined;
    riderAccounts: RiderAccount[] | undefined;
    fare: number | undefined;
    outOfCountyFare: number | undefined;
    deductFareCollected: boolean | undefined;
    maximumFareCharge: number | undefined;
    fareCalculationMethod: number | undefined;
    fareMileageRates: AccountFareMileageRate[] | undefined;
}

export interface AccountBillMethod {
    billableRide: boolean;
    tripCharge: boolean;
    mileCharge: boolean;
    hourCharge: boolean;
    beginOdomStartOdom: boolean;
    pickupOdomLastDropoffOdom: boolean;
    tripStartTimeTripEndTime: boolean;
    passOnTimeLastPassOffTime: boolean;
    passTrip: boolean;
    passMile: boolean;
    passHour: boolean;
    bzoneCharge: boolean;
    shareMile: boolean;
    shareHour: boolean;
    shareRide: boolean;
    shareTrip: boolean;
    firstPickupOdomTripEndOdom: boolean;
    passTripPlus: boolean;
    extraCharge: boolean;
    accountTrip: boolean;
    specialTrip: boolean;
    minMaxTripMiles: boolean;
    maxCharge: boolean;
    minCharge: boolean;
    minMiles: boolean;
    maxMiles: boolean;
    waitCharge: boolean;
    wheelchairCharge: boolean;
    fareCharge: boolean;
    escortCharge: boolean;
    directMileage: boolean;
    noShowExtra: boolean;
    readonly billMethodIdAsLoaded: number;
    billMethodId: number;
}

export interface AccountCharge {
    accountChargeId: number;
    accountId: number;
    description: string | undefined;
    code: string | undefined;
    chargeTypeId: number;
    costPerUnit: number;
    freeUnits: number | undefined;
    minimumUnits: number | undefined;
    maximumUnits: number | undefined;
    dbStatus: number;
    account: Account;
    chargeType: ChargeType;
    fixedRideCharges: FixedRideCharge[] | undefined;
    rideCharges: RideCharge[] | undefined;
}

export interface AccountFareMileageRate {
    accountFareMileageRateId: number;
    accountId: number;
    mobilityTypeId: number;
    minimumMileage: number;
    baseRate: number;
    mileageRate: number;
    account: Account;
}

export interface AdditionalPassengers {
    attendants: number | undefined;
    children: number | undefined;
}

export interface Address {
    id: string | undefined;
    name: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    county: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    phone: string | undefined;
}

export interface AddressListResponse {
    addresses: Address[] | undefined;
    count: number;
}

export interface AddressModel {
    addressId: string | undefined;
    name: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    county: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    phone: string | undefined;
    isFavorite: boolean;
}

export interface Agency {
    id: number;
    name: string | undefined;
    phone: string | undefined;
    dbStatus: number;
    useSharedBillingAgency: boolean;
    locationId: number | undefined;
    location: Location;
    accounts: Account[] | undefined;
}

export interface ApprovedDelegateRider {
    riderId: number;
    riderFullName: string | undefined;
    riderPhoneNumber: string | undefined;
}

export interface ApprovedVendor {
    approvedVendorId: number;
    serviceId: number;
    vendorId: number;
    quotedCost: number | undefined;
    isDefault: boolean | undefined;
    service: Service;
    vendor: Vendor;
}

export interface BillingZone {
    billingZoneId: number;
    zone: string | undefined;
    rate: number;
    date: Date | undefined;
    dbstatus: number;
    fixedRides: FixedRide[] | undefined;
    rides: Ride[] | undefined;
}

export interface BrokerContract {
    brokerContractId: string;
    brokerId: number;
    remoteBrokerId: number | undefined;
    defaultAccountId: number | undefined;
    defaultPurposeId: number | undefined;
    mileageRateProfileId: number | undefined;
    brokerCompanyKey: string | undefined;
    brokerSpecificData: string | undefined;
    reportEventsToBroker: boolean | undefined;
    licenseAgreementSigned: Date | undefined;
    pickupAdjustmentInMinutes: number | undefined;
    dropoffAdjustmentInMinutes: number | undefined;
    isActive: boolean;
    defaultAccount: Account;
    defaultPurpose: Purpose;
    mileageRateProfile: MileageRateProfile;
    vehicles: BrokerVehicle[] | undefined;
    drivers: BrokerDriver[] | undefined;
    riders: BrokerRider[] | undefined;
    rides: Ride[] | undefined;
}

export interface BrokerDriver {
    brokerDriverId: number;
    driverReferenceId: string | undefined;
    brokerId: number;
    brokerContractId: string;
    driverId: number;
    lastName: string | undefined;
    firstName: string | undefined;
    dob: Date | undefined;
    licenseNumber: string | undefined;
    licenseState: string | undefined;
    isActive: boolean;
    brokerJson: string | undefined;
    driver: Driver;
    brokerContract: BrokerContract;
}

export interface BrokerRider {
    brokerRiderId: number;
    riderReferenceId: string | undefined;
    brokerId: number;
    brokerContractId: string;
    riderId: number;
    lastName: string | undefined;
    firstName: string | undefined;
    dob: Date | undefined;
    phone: string | undefined;
    isActive: boolean;
    brokerJson: string | undefined;
    rider: Rider;
    brokerContract: BrokerContract;
}

export interface BrokerVehicle {
    brokerVehicleId: number;
    vehicleReferenceId: string | undefined;
    brokerId: number;
    brokerContractId: string;
    vehicleId: number;
    licensePlate: string | undefined;
    licensePlateState: string | undefined;
    vin: string | undefined;
    webHookUrl: string | undefined;
    isActive: boolean;
    brokerJson: string | undefined;
    vehicle: Vehicle;
    brokerContract: BrokerContract;
}

export interface CancelRideRequestResponse {
    responseMessage: string | undefined;
    cancelled: boolean;
}

export interface Certification {
    certificationID: number;
    name: string | undefined;
    interval: number;
    dbstatus: number;
    driverCertifications: DriverCertification[] | undefined;
}

export interface ChargeType {
    chargeTypeId: number;
    description: string | undefined;
    dbStatus: number;
    accountCharges: AccountCharge[] | undefined;
}

export interface Company {
    companyId: number;
    companyName: string | undefined;
    invoicePayableTo: string | undefined;
    dueWithinDays: number;
    openHour: string | undefined;
    closeHour: string | undefined;
    firstMonthFiscalYear: string | undefined;
    normalFuelCost: number;
    fuelAdjFactor: number;
    providerNumber: string | undefined;
    fedTaxNumber: string | undefined;
    stateTaxNumber: string | undefined;
    companyPhoneNumber: string | undefined;
    companyFaxNumber: string | undefined;
    companyModemNumber: string | undefined;
    recipientName: string | undefined;
    recipientIdnumber: string | undefined;
    recipientPhoneNumber: string | undefined;
    recipientUrl: string | undefined;
    brokerNumber: string | undefined;
    regionCode: string | undefined;
    countyCode: string | undefined;
    garagingMaxDistance: number;
    ncopstatsmedicaid: string | undefined;
    ncopstatsnoncontract: string | undefined;
    defaultLastRodeAcct: boolean | undefined;
    defaultReturnRide: boolean | undefined;
    howLateIsLate: number;
    unitsOfMeasure: string | undefined;
    returnRideTimeDifference: number;
    sendMdttargetRadius: boolean;
    roundDirectMileage: boolean;
    cancelFutureRidesAfterNoShow: boolean | undefined;
    ilsenior: string | undefined;
    ildisabled: string | undefined;
    easternTimeOffset: number;
    timeZoneName: string | undefined;
    gmthourOffset: number;
    ivrActive: boolean;
    tripsheetFooter: string | undefined;
    modernReportViewerEnabled: boolean;
    driverSignatureRequired: boolean;
    dbstatus: number;
    companyLocationId: number;
    recipientLocationId: number;
    garageLocationId: number | undefined;
    allowLocationEdit: boolean;
    defaultTimeWindowFactor: number | undefined;
    defaultExcessTransitFactor: number | undefined;
    defaultRouteZoneMilesFromDepot: number | undefined;
    defaultCostPerMile: number | undefined;
    defaultCostPerHour: number | undefined;
    useTraffic: boolean;
    defaultFlagStopRiderId: number | undefined;
    defaultRiderTypeId: number;
    allowQuickPerform: boolean;
    allowOnTheWay: boolean;
    paraScopeGpsReportingInterval: number | undefined;
    certificationNotificationEmail: string | undefined;
    certificationNotificationInterval: number | undefined;
    urbanToRuralIsUrban: boolean | undefined;
    ruralToUrbanIsUrban: boolean | undefined;
    triggerOTWRemindersFromParaScope: boolean | undefined;
    lcapiKey: string | undefined;
    lcAccountId: number | undefined;
    reportEventsToLogistiCare: boolean;
    fairmaticAuditModeEnabled: boolean;
    defaultRiderType: RiderType;
    companyLocation: Location;
    defaultFlagStopRider: Rider;
    garageLocation: Location;
    lcAccount: Account;
    recipientLocation: Location;
}

export interface Coordinate {
    latitude: number;
    longitude: number;
}

export interface CreateDelegateUserResponse {
    portalUserResourceId: string | undefined;
    userIsAlreadyRegistered: boolean;
}

export interface CreateRideRequest {
    priority: Priority;
    pickupTimePreference: Date | undefined;
    pickupAddress: Address;
    dropoffAddress: Address;
    comments: string | undefined;
    additionalPassengers: AdditionalPassengers;
    wheelchairRequired: boolean | undefined;
    stretcherRequired: boolean | undefined;
    riderId: string;
}

export interface CreateRideResponse {
    priority: Priority;
    pickupTimePreference: Date | undefined;
    pickupAddress: Address;
    dropoffAddress: Address;
    comments: string | undefined;
    additionalPassengers: AdditionalPassengers;
    wheelchairRequired: boolean | undefined;
    stretcherRequired: boolean | undefined;
    riderId: string;
    rideId: string;
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum DbStatus {
    _0 = 0,
    _1 = 1,
}

export interface DelegateUserRideRequest {
    reservationType: string | undefined;
    rideDate: Date | undefined;
    pickupTime: Date | undefined;
    dropoffTime: Date | undefined;
    pickupAddress: AddressModel;
    dropoffAddress: AddressModel;
    comments: string | undefined;
    rideRequirements: number[] | undefined;
    escorts: number;
    vendorRiderId: string | undefined;
    newDelegateUserProfile: UserProfile;
    pickupAddressId: number;
    dropoffAddressId: number;
    purposeId: number | undefined;
}

export interface DeviceChannelResponse {
    storeUpdateRequired: boolean;
    channel: string | undefined;
}

export interface DeviceModel {
    uuid: string | undefined;
    playStoreVersion: string | undefined;
    buildVersion: string | undefined;
    ionicSnapshotBuildId: string | undefined;
    ionicChannel: string | undefined;
    capacitorVersion: string | undefined;
    model: string | undefined;
    platform: string | undefined;
    platformVersion: string | undefined;
    manufacturer: string | undefined;
    serialNumber: string | undefined;
}

export interface DispatchMessage {
    messageId: number;
    text: string | undefined;
    originalMessageId: number | undefined;
    vehicleId: number | undefined;
    status: string | undefined;
    fromUserId: string | undefined;
    toUserId: string | undefined;
    messageDateTime: Date | undefined;
    priority: number | undefined;
    messageType: number | undefined;
    dbStatus: number | undefined;
    direction: string | undefined;
    driverId: number | undefined;
    acceptedBy: string | undefined;
    acceptedOn: Date | undefined;
    requiresAcceptance: boolean | undefined;
    deliveryStatus: number;
    driver: Driver;
    dispatchMessage2: DispatchMessage;
    vehicle: Vehicle;
    dispatchMessage1: DispatchMessage[] | undefined;
}

export interface Driver {
    driverId: number;
    lastName: string | undefined;
    firstName: string | undefined;
    middleInitial: string | undefined;
    ssn: string | undefined;
    dob: Date | undefined;
    phone: string | undefined;
    driverCode: string | undefined;
    dateEmployed: Date | undefined;
    licenseNumber: string | undefined;
    licenseState: string | undefined;
    licenseClass: string | undefined;
    licenseExpiresDate: Date | undefined;
    hourlyWage: number | undefined;
    driverRemarks: string | undefined;
    payrollNumber: string | undefined;
    idnumber: number | undefined;
    dbstatus: number;
    locationId: number | undefined;
    canServeChildren: boolean | undefined;
    lcdriverId: number | undefined;
    location: Location;
    brokerReferences: BrokerDriver[] | undefined;
    driverSpecialAssistances: DriverSpecialAssistance[] | undefined;
    fixedTrips: FixedTrip[] | undefined;
    tripDrivers: Trip[] | undefined;
    tripEscorts: Trip[] | undefined;
    tripTrainees: Trip[] | undefined;
    vehicles: Vehicle[] | undefined;
    dispatchMessages: DispatchMessage[] | undefined;
    driverExcludedRiders: DriverExcludedRider[] | undefined;
    driverCertifications: DriverCertification[] | undefined;
}

export interface DriverCertification {
    certificationID: number;
    driverID: number;
    dueDate: Date;
    completedDate: Date;
    certification: Certification;
    driver: Driver;
}

export interface DriverExcludedRider {
    driverId: number;
    riderId: number;
    driver: Driver;
    rider: Rider;
}

export interface DriverModel {
    firstName: string | undefined;
    lastName: string | undefined;
}

export interface DriverSession {
    driverSessionId: number;
    deviceIdentifier: string | undefined;
    deviceDescription: string | undefined;
    tripId: number;
    lastUpdateRequested: Date | undefined;
    lastCommunication: Date;
    loginDate: Date;
    lastSentRouteUpdate: string | undefined;
    trip: Trip;
}

export interface DriverSpecialAssistance {
    driverId: number;
    specialAssistanceId: number;
    driver: Driver;
    specialAssistance: SpecialAssistance;
}

export interface EmailAccountDetails {
    emailFound: boolean;
    emailConfirmed: boolean;
    isDelegateAccount: boolean;
}

export enum FixedRecursionFlags {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
}

export interface FixedRide {
    fixedRideId: number;
    fixedTripId: number | undefined;
    recursion: FixedRecursionFlags;
    riderId: number;
    riderAccountId: number;
    purposeId: number | undefined;
    fareAmount: number | undefined;
    comments: string | undefined;
    scheduledPickupTime: string | undefined;
    scheduledDropoffTime: string | undefined;
    wheelChairFlag: boolean | undefined;
    escortNeeded: boolean | undefined;
    billingZoneId: number | undefined;
    areaId: number | undefined;
    suspendDateBegin: Date | undefined;
    suspendDateEnd: Date | undefined;
    numChildren: number | undefined;
    status: number | undefined;
    dbstatus: number | undefined;
    initialRideFlag: boolean | undefined;
    goldWeek: boolean | undefined;
    zoneRate: number | undefined;
    numEscorts: number | undefined;
    willCall: boolean | undefined;
    authNum: string | undefined;
    excludeFromAutoschedule: boolean | undefined;
    sensitivity: boolean | undefined;
    lockOnTrip: boolean | undefined;
    directMileage: number | undefined;
    providerId: number | undefined;
    overnight: number | undefined;
    ivrNightBefore: boolean;
    ivrOnTheWay: boolean;
    activeDateBegin: Date | undefined;
    activeDateEnd: Date | undefined;
    priorityTime: string | undefined;
    rideAlertProviderId: number | undefined;
    startDate: Date;
    scheduleProfileId: number | undefined;
    directMileageOverride: number | undefined;
    directDriveDuration: TimeSpan;
    directDriveDurationOverride: TimeSpan;
    stretcher: boolean;
    rideChargeAdjustment: number;
    signatureRequired: boolean | undefined;
    liftRequired: boolean;
    chargeOverride: number | undefined;
    chargeOverrideComments: string | undefined;
    pickupLocationId: number;
    pickupCode: string | undefined;
    dropoffLocationId: number;
    dropoffCode: string | undefined;
    pickupPhone: string | undefined;
    dropoffPhone: string | undefined;
    nonPriorityTime: string | undefined;
    earliestPickupTime: string | undefined;
    latestPickupTime: string | undefined;
    earliestDropoffTime: string | undefined;
    latestDropoffTime: string | undefined;
    bzone: BillingZone;
    dropoffLocation: Location;
    fixedTrip: FixedTrip;
    pickupLocation: Location;
    provider: Provider;
    purpose: Purpose;
    rideAlertProvider: RideAlertProvider;
    rider: Rider;
    riderAccount: RiderAccount;
    fixedRideCharges: FixedRideCharge[] | undefined;
    fixedRideSpecialAssistances: FixedRideSpecialAssistance[] | undefined;
    rides: Ride[] | undefined;
    autoCalculatedFare: number | undefined;
    readonly recurDaysString: string | undefined;
    recurDays: DayOfWeek[] | undefined;
    recurType: SubscriptionRecurType;
}

export interface FixedRideCharge {
    fixedRideId: number;
    accountChargeId: number;
    accountCharge: AccountCharge;
    fixedRide: FixedRide;
}

export interface FixedRideSpecialAssistance {
    fixedRideId: number;
    specialAssistanceId: number;
    fixedRide: FixedRide;
    specialAssistance: SpecialAssistance;
}

export interface FixedTrip {
    fixedTripId: number;
    vehicleId: number | undefined;
    driverId: number | undefined;
    recursion: FixedRecursionFlags;
    purposeId: number | undefined;
    description: string | undefined;
    number: number | undefined;
    remarks: string | undefined;
    scheduledStartTime: string | undefined;
    scheduledEndTime: string | undefined;
    status: number | undefined;
    dbstatus: DbStatus;
    return: number | undefined;
    excludeFromAutoschedule: boolean | undefined;
    locked: boolean | undefined;
    includePreTrip: boolean | undefined;
    includePostTrip: boolean | undefined;
    includeBreak: boolean | undefined;
    preTripDuration: number | undefined;
    postTripDuration: number | undefined;
    breakScheduledStartTime: string | undefined;
    breakDuration: number | undefined;
    breakWindowOpen: string | undefined;
    breakWindowClose: string | undefined;
    providerId: number | undefined;
    overnight: number | undefined;
    blackoutStartTime: string | undefined;
    includeBlackout: boolean;
    blackoutDuration: number;
    icb: boolean;
    availableStartTime: string | undefined;
    availableEndTime: string | undefined;
    rural: boolean | undefined;
    demandResponse: boolean | undefined;
    directlyOperated: boolean | undefined;
    startDepotLocationId: number | undefined;
    endDepotLocationId: number | undefined;
    enableFlagStops: boolean;
    gtfsBlockId: number | undefined;
    allowMicrotransitRides: boolean;
    maxAllowableHours: string | undefined;
    driver: Driver;
    endDepotLocation: Location;
    provider: Provider;
    purpose: Purpose;
    startDepotLocation: Location;
    vehicle: Vehicle;
    flagStopBlockRoute: GtfsBlock;
    fixedRides: FixedRide[] | undefined;
    trips: Trip[] | undefined;
    fixedTripOverlays: FixedTripOverlay[] | undefined;
    readonly recurDaysString: string | undefined;
    recurDays: DayOfWeek[] | undefined;
}

export interface FixedTripOverlay {
    fixedTripOverlayId: number;
    fixedTripId: number;
    mapOverlayId: number;
    startTime: string | undefined;
    endTime: string | undefined;
    fixedTrip: FixedTrip;
    mapOverlay: MapOverlay;
}

export interface FlagStopJob {
    id: number;
    performedFlagStopId: number;
    isPickup: boolean;
    riderTypeId: number;
    units: number;
    fareCollected: number;
    unitCost: number;
    performedFlagStop: PerformedFlagStop;
    riderType: RiderType;
}

export interface GenderType {
    genderId: number;
    name: string | undefined;
    description: string | undefined;
}

export interface GpsReport {
    gpsReportId: number;
    latitude: number | undefined;
    longitude: number | undefined;
    gpsDateTime: Date | undefined;
    dateTimeReported: Date | undefined;
    speed: number | undefined;
    direction: string | undefined;
    status: string | undefined;
    vehicleId: number | undefined;
    tripId: number | undefined;
    heading: number | undefined;
    odometer: number | undefined;
    milesFromPreviousReport: number | undefined;
    trip: Trip;
    vehicle: Vehicle;
    vehicleCurrentStatus: VehicleCurrentStatus;
}

export enum GtfsAccessibility {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface GtfsAgency {
    gtfsAgencyId: number;
    gtfsImportId: string;
    agencyImportId: string | undefined;
    name: string | undefined;
    url: string | undefined;
    timeZone: string | undefined;
    languageCode: string | undefined;
    phone: string | undefined;
    fareUrl: string | undefined;
    email: string | undefined;
    routes: GtfsRoute[] | undefined;
}

export interface GtfsBlock {
    gtfsBlockId: number;
    gtfsImportId: string;
    blockId: string | undefined;
    trips: GtfsTrip[] | undefined;
}

export interface GtfsCalendar {
    gtfsCalendarId: number;
    gtfsImportId: string;
    serviceImportId: string | undefined;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
    startDate: Date;
    endDate: Date;
    trips: GtfsTrip[] | undefined;
    exceptions: GtfsCalendarDate[] | undefined;
}

export interface GtfsCalendarDate {
    gtfsCalendarDateId: number;
    gtfsCalendarId: number | undefined;
    serviceImportId: string | undefined;
    exceptionDate: Date;
    exceptionType: GtfsExceptionType;
    calendar: GtfsCalendar;
}

export enum GtfsDirection {
    _0 = 0,
    _1 = 1,
}

export enum GtfsExceptionType {
    _1 = 1,
    _2 = 2,
}

export enum GtfsLocationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface GtfsRoute {
    gtfsRouteId: number;
    gtfsAgencyId: number | undefined;
    gtfsImportId: string;
    routeImportId: string | undefined;
    agencyImportId: string | undefined;
    shortName: string | undefined;
    longName: string | undefined;
    description: string | undefined;
    routeType: GtfsRouteType;
    url: string | undefined;
    color: string | undefined;
    textColor: string | undefined;
    sortOrder: number | undefined;
    agency: GtfsAgency;
    trips: GtfsTrip[] | undefined;
}

export enum GtfsRouteType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export interface GtfsStop {
    gtfsStopId: number | undefined;
    gtfsImportId: string;
    stopImportId: string | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    latitude: number;
    longitude: number;
    zoneId: string | undefined;
    url: string | undefined;
    locationType: GtfsLocationType;
    parentStation: string | undefined;
    timeZone: string | undefined;
    wheelchairBoarding: GtfsAccessibility;
    stopTimes: GtfsStopTime[] | undefined;
}

export interface GtfsStopTime {
    gtfsStopTimeId: number;
    gtfsStopId: number | undefined;
    gtfsTripId: number | undefined;
    stopImportId: string | undefined;
    tripImportId: string | undefined;
    arrivalTime: TimeSpan;
    departureTime: TimeSpan;
    sequence: number;
    headsign: string | undefined;
    pickupType: GtfsStopType;
    dropoffType: GtfsStopType;
    shapeDistanceTraveled: number | undefined;
    timePoint: GtfsTimePoint;
    trip: GtfsTrip;
    stop: GtfsStop;
    performedFlagStops: PerformedFlagStop[] | undefined;
}

export enum GtfsStopType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum GtfsTimePoint {
    _0 = 0,
    _1 = 1,
}

export interface GtfsTrip {
    gtfsTripId: number;
    gtfsRouteId: number | undefined;
    gtfsCalendarId: number | undefined;
    gtfsBlockId: number | undefined;
    tripImportId: string | undefined;
    routeImportId: string | undefined;
    serviceImportId: string | undefined;
    shapeImportId: string | undefined;
    headsign: string | undefined;
    shortName: string | undefined;
    directionId: GtfsDirection;
    blockId: string | undefined;
    wheelchairAccessible: GtfsAccessibility;
    bikesAllowed: GtfsAccessibility;
    route: GtfsRoute;
    calendar: GtfsCalendar;
    block: GtfsBlock;
    stopTimes: GtfsStopTime[] | undefined;
}

export interface Income {
    incomeId: number;
    description: string | undefined;
    dbstatus: number;
    tblRider: Rider[] | undefined;
}

export interface Inspection {
    inspectionId: number;
    tripId: number;
    vehicleId: number;
    inspectionType: InspectionType;
    completedDate: Date;
    trip: Trip;
    vehicle: Vehicle;
    inspectionResults: InspectionResult[] | undefined;
}

export enum InspectionAnswer {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface InspectionItem {
    inspectionItemId: number;
    serviceCategoryId: number;
    questionType: InspectionQuestionType;
    description: string | undefined;
    preTrip: boolean;
    postTrip: boolean;
    critical: boolean;
    dbStatus: number;
    serviceCategory: ServiceCategory;
    inspectionResults: InspectionResult[] | undefined;
}

export enum InspectionQuestionType {
    _0 = 0,
    _1 = 1,
}

export interface InspectionResult {
    inspectionResultId: number;
    inspectionId: number;
    inspectionItemId: number;
    result: InspectionAnswer;
    textResult: string | undefined;
    inspection: Inspection;
    inspectionItem: InspectionItem;
}

export enum InspectionType {
    _1 = 1,
    _2 = 2,
}

export interface Language {
    languageId: number;
    description: string | undefined;
    dbstatus: number;
    tblRider: Rider[] | undefined;
}

export interface ListRidesRequest {
    rideStatusFilter: number[] | undefined;
    sortColumnName: string | undefined;
    sortDirectionIsDescending: boolean;
    takeAmount: number;
    skipAmount: number;
    searchTerm: string | undefined;
    pastRides: boolean;
    ridePaymentStatusFilter: number[] | undefined;
}

export interface Location {
    name: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    zipCode: string | undefined;
    state: string | undefined;
    city: string | undefined;
    county: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    locationId: number;
    suggest: boolean | undefined;
    defaultSiteCode: string | undefined;
    defaultPhone: string | undefined;
    isHub: boolean;
    isUrban: boolean | undefined;
    companyCompanyLocations: Company[] | undefined;
    companyGarageLocations: Company[] | undefined;
    companyRecipientLocations: Company[] | undefined;
    drivers: Driver[] | undefined;
    fixedRideDropoffLocations: FixedRide[] | undefined;
    fixedRidePickupLocations: FixedRide[] | undefined;
    fixedTripEndDepotLocations: FixedTrip[] | undefined;
    fixedTripStartDepotLocations: FixedTrip[] | undefined;
    providers: Provider[] | undefined;
    rideDropoffLocations: Ride[] | undefined;
    ridePickupLocations: Ride[] | undefined;
    riderBillingLocations: Rider[] | undefined;
    riderContactLocations: Rider[] | undefined;
    riderDoctorLocations: Rider[] | undefined;
    riderHomeLocations: Rider[] | undefined;
    tripEndDepotLocations: Trip[] | undefined;
    tripStartDepotLocations: Trip[] | undefined;
    vehicles: Vehicle[] | undefined;
    agencies: Agency[] | undefined;
}

export interface LoginResponseModel {
    token: string | undefined;
    userProfile: UserProfile;
}

export interface MaintenancePlan {
    id: number;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    serviceSchedules: ServiceSchedule[] | undefined;
    vehicles: Vehicle[] | undefined;
}

export interface MapOverlay {
    mapOverlayId: number;
    mapOverlayType: MapOverlayTypeEnum;
    blobUri: string | undefined;
    name: string | undefined;
    zIndex: number | undefined;
    createdByUser: string | undefined;
    dateCreated: Date | undefined;
    displayOn: string | undefined;
    tripOverlays: TripOverlays[] | undefined;
    fixedTripOverlays: FixedTripOverlay[] | undefined;
}

export enum MapOverlayTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export interface MileageRate {
    mileageRateId: number | undefined;
    mileageRateProfileId: number | undefined;
    levelOfService: string | undefined;
    baseRate: number;
    unitRate: number | undefined;
    startMileage: number;
    endMileage: number;
    isActive: boolean;
    mileageRateProfile: MileageRateProfile;
}

export interface MileageRateProfile {
    mileageRateProfileId: number | undefined;
    description: string | undefined;
    isActive: boolean;
    mileageRates: MileageRate[] | undefined;
    brokerContracts: BrokerContract[] | undefined;
}

export interface NewUserProfile {
    firstName: string | undefined;
    middleInitial: string | undefined;
    lastName: string | undefined;
    genderId: number | undefined;
    genderDescription: string | undefined;
    dateOfBirth: string | undefined;
    phoneNumber: string | undefined;
    address: AddressModel;
    rideRequirements: RideRequirementTypes[] | undefined;
    prefersTextMessage: boolean;
}

export interface OutOfServicePeriod {
    outOfServicePeriodId: number;
    vehicleId: number;
    periodStart: Date;
    periodEnd: Date;
    notes: string | undefined;
    vehicle: Vehicle;
}

export interface OutOfServiceRange {
    start: Date;
    end: Date | undefined;
}

export interface Pass {
    id: string;
    riderId: number | undefined;
    effectiveDate: Date | undefined;
    expirationDate: Date | undefined;
    maxRideCount: number | undefined;
    isActive: boolean;
    created: Date;
    passTypeId: number;
    riderTypeId: number;
    externalPassId: string | undefined;
    isEPass: boolean;
    passTransactions: PassTransaction[] | undefined;
    rider: Rider;
    passType: PassType;
    riderType: RiderType;
    passAudits: PassAudit[] | undefined;
}

export interface PassAudit {
    passAuditId: number;
    passId: string;
    doneOn: Date;
    doneBy: string | undefined;
    description: string | undefined;
    pass: Pass;
    notes: string | undefined;
}

export interface PassTransaction {
    id: string;
    passId: string;
    amount: number | undefined;
    purchaserName: string | undefined;
    userName: string | undefined;
    created: Date;
    rideId: number | undefined;
    flagStopJobId: number | undefined;
    transferedFromTransactionId: string | undefined;
    gpsOccuranceDateUtc: Date | undefined;
    notes: string | undefined;
    usedByRide: Ride;
    pass: Pass;
    transferedFromTransaction: PassTransaction;
    flagStopJob: FlagStopJob;
    transferedToTransactions: PassTransaction[] | undefined;
}

export interface PassType {
    id: number;
    integrationId: string;
    description: string | undefined;
    riderTypeId: number | undefined;
    isActive: boolean;
    passes: Pass[] | undefined;
    riderType: RiderType;
}

export interface PaymentAssignmentModel {
    transportationProviderId: string | undefined;
    paymentToken: PaymentTokenModel;
    rideIds: string[] | undefined;
    requestId: string;
}

export interface PaymentProvider {
    paymentProviderId: number;
    providerType: string | undefined;
    configuration: string | undefined;
    createdDate: Date;
    type: PaymentProviderType;
    riderPaymentMethods: RiderPaymentMethod[] | undefined;
}

export interface PaymentProviderSettings {
    apiKey: string | undefined;
    providerId: number;
    providerType: string | undefined;
}

export enum PaymentProviderType {
    _0 = 0,
}

export interface PaymentTokenModel {
    card_exp: string | undefined;
    card_exp_datetime: string | undefined;
    card_last_four: string | undefined;
    card_type: string | undefined;
    created_at: string | undefined;
    id: string | undefined;
    provider_id: number;
}

export interface PerformedFlagStop {
    id: number;
    tripId: number;
    arriveDate: Date | undefined;
    completedDate: Date | undefined;
    odometer: number;
    latitude: number;
    longitude: number;
    gtfsStopTimeId: number | undefined;
    scheduledArrivalDate: Date | undefined;
    scheduledDepartureDate: Date | undefined;
    scheduledFlagStop: GtfsStopTime;
    trip: Trip;
    flagStopJobs: FlagStopJob[] | undefined;
}

export interface PortalDelegate {
    id: number;
    delegateOrganizationId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    tripPortalResourceId: string | undefined;
    tripPortalInvitationConfirmed: boolean;
    isEnabled: boolean;
    portalDelegateOrganization: PortalDelegateOrganization;
}

export interface PortalDelegateOrganization {
    id: number | undefined;
    name: string | undefined;
    primaryContactPhone: string | undefined;
    canCreateRequestsForAllRiders: boolean;
    enabled: boolean;
    portalDelegates: PortalDelegate[] | undefined;
    portalDelegateOrganizationRiders: PortalDelegateOrganizationRider[] | undefined;
    description: string | undefined;
    isActive: boolean;
    tripPortalResourceId: string | undefined;
    approvedDelegateRiders: ApprovedDelegateRider[] | undefined;
}

export interface PortalDelegateOrganizationRider {
    riderId: number;
    delegateOrganizationId: number;
    portalDelegateOrganization: PortalDelegateOrganization;
    rider: Rider;
}

export enum PortalUserRegistrationStatusEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export interface PortalUserRideRequest {
    portalUserRideRequestId: number;
    tripPortalResourceId: string | undefined;
    rideRequestStatus: number;
    acknowledged: Date | undefined;
    completed: Date | undefined;
    created: Date;
    tblRideId: number | undefined;
    reasonMessage: string | undefined;
    tblRide: Ride;
}

export interface Priority {
    kind: PriorityKind;
    dateTime: Date | undefined;
    date: Date | undefined;
}

export enum PriorityKind {
    Pickup = "Pickup",
    Dropoff = "Dropoff",
    WillCall = "WillCall",
}

export interface ProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export interface Provider {
    providerId: number;
    name: string | undefined;
    contact: string | undefined;
    phone: string | undefined;
    taxId: string | undefined;
    fedTaxNumber: string | undefined;
    stateTaxNumber: string | undefined;
    idnumber1: string | undefined;
    idnumber2: string | undefined;
    idnumber3: string | undefined;
    dbstatus: number;
    locationId: number | undefined;
    lyftRideDelegationProgramId: string | undefined;
    location: Location;
    fixedRides: FixedRide[] | undefined;
    fixedTrips: FixedTrip[] | undefined;
    riders: Rider[] | undefined;
    rides: Ride[] | undefined;
    trips: Trip[] | undefined;
}

export interface Purpose {
    purposeId: number;
    description: string | undefined;
    dbstatus: number;
    fixedRides: FixedRide[] | undefined;
    fixedTrips: FixedTrip[] | undefined;
    rides: Ride[] | undefined;
    trips: Trip[] | undefined;
    brokerContracts: BrokerContract[] | undefined;
}

export interface Race {
    raceId: number;
    description: string | undefined;
    dbstatus: number;
    tblRider: Rider[] | undefined;
}

export interface ReminderCall {
    reminderCallId: string;
    rideId: number;
    callType: number;
    createdDate: Date;
    ride: Ride;
    reminderCallAttempts: ReminderCallAttempt[] | undefined;
}

export interface ReminderCallAttempt {
    reminderCallAttemptId: string;
    reminderCallId: string;
    status: number;
    createdDate: Date;
    lastModifiedDate: Date;
    attemptCount: number;
    duration: TimeSpan;
    message: string | undefined;
    exception: string | undefined;
    rideAlertProviderId: number | undefined;
    reminderCall: ReminderCall;
    rideAlertProvider: RideAlertProvider;
}

export interface ReminderTextMessage {
    reminderTextMessageId: string;
    rideId: number;
    rideAlertProviderId: number;
    reminderType: number;
    createdDate: Date;
    message: string | undefined;
    status: number;
    exception: string | undefined;
    ride: Ride;
    rideAlertProvider: RideAlertProvider;
}

export interface RequestRideResponse {
    responseDetails: RideRequestDetails;
    transportationProvider: TransportationProviderModel;
}

export interface Ride {
    rideId: number;
    tripId: number | undefined;
    riderId: number;
    riderAccountId: number;
    purposeId: number | undefined;
    fixedRideId: number | undefined;
    rideDate: Date | undefined;
    scheduledDropoffTime: string | undefined;
    scheduledPickupTime: string | undefined;
    pickupArrivalTime: string | undefined;
    dropoffArrivalTime: string | undefined;
    actualPickupTime: string | undefined;
    actualDropoffTime: string | undefined;
    startOdometer: number | undefined;
    endOdometer: number | undefined;
    fareAmount: number | undefined;
    autoCalculatedFare: number | undefined;
    fareCollected: number | undefined;
    wheelChairFlag: boolean | undefined;
    comments: string | undefined;
    status: number;
    noShowReason: number | undefined;
    escortNeeded: boolean | undefined;
    billingZoneId: number | undefined;
    areaId: number | undefined;
    zoneRate: number | undefined;
    billable: boolean | undefined;
    denyServiceId: number | undefined;
    units: number | undefined;
    numChildren: number | undefined;
    dbstatus: number | undefined;
    initialRideFlag: boolean | undefined;
    excludeWait: boolean | undefined;
    dateRecorded: Date | undefined;
    numEscorts: number | undefined;
    autoscheduled: boolean | undefined;
    willCall: boolean | undefined;
    originalTripId: number | undefined;
    authNum: string | undefined;
    excludeFromAutoschedule: boolean | undefined;
    numClients: number | undefined;
    sensitivity: boolean | undefined;
    lockOnTrip: boolean | undefined;
    directMileage: number | undefined;
    providerId: number | undefined;
    actualDropoffDateTime: Date | undefined;
    actualPickupDateTime: Date | undefined;
    overnight: number | undefined;
    pickupArrivalOdometer: number | undefined;
    scheduledDropoffDateTime: Date | undefined;
    scheduledPickupDateTime: Date | undefined;
    ivrNightBefore: boolean;
    ivrOnTheWay: boolean;
    noShowDateTime: Date | undefined;
    pickupArrivalDateTime: Date | undefined;
    priorityTime: string | undefined;
    rideAlertProviderId: number | undefined;
    willCallReady: Date | undefined;
    flagStopId: string | undefined;
    scheduleProfileId: number | undefined;
    directMileageOverride: number | undefined;
    directDriveDuration: TimeSpan;
    directDriveDurationOverride: TimeSpan;
    stretcher: boolean;
    rideChargeAdjustment: number;
    dateDenied: Date | undefined;
    signatureRequired: boolean | undefined;
    pickupActualLatitude: number | undefined;
    pickupActualLongitude: number | undefined;
    dropoffActualLatitude: number | undefined;
    dropoffActualLongitude: number | undefined;
    pickupArrivalLatitude: number | undefined;
    pickupArrivalLongitude: number | undefined;
    dropoffArrivalLatitude: number | undefined;
    dropoffArrivalLongitude: number | undefined;
    liftRequired: boolean | undefined;
    chargeOverride: number | undefined;
    chargeOverrideComments: string | undefined;
    waitStartTime: string | undefined;
    waitEndTime: string | undefined;
    waitTimeOverrideMinutes: number | undefined;
    pickupLocationId: number;
    pickupCode: string | undefined;
    dropoffLocationId: number;
    dropoffCode: string | undefined;
    pickupPhone: string | undefined;
    dropoffPhone: string | undefined;
    additionalMilesFromDepot: number;
    webHookUrl: string | undefined;
    importSource: string | undefined;
    levelOfService: string | undefined;
    onTheWayTime: string | undefined;
    onTheWayLatitude: number | undefined;
    onTheWayLongitude: number | undefined;
    driverPickupNotes: string | undefined;
    driverDropoffNotes: string | undefined;
    canceledDateTime: Date | undefined;
    canceledLatitude: number | undefined;
    canceledLongitude: number | undefined;
    brokerCancelDenyReason: string | undefined;
    estimatedTimeOfArrival: string | undefined;
    pickupOnTheWayEta: Date | undefined;
    createdDate: Date | undefined;
    lastModifiedDate: Date | undefined;
    errors: string | undefined;
    rideRequestId: number | undefined;
    logistiCareRideId: string | undefined;
    logistiCareInvoiced: Date | undefined;
    previousLogistiCarePriorityTime: string | undefined;
    previousLogistiCarePickupLocation: string | undefined;
    previousLogistiCareDropoffLocation: string | undefined;
    originalScheduledPickupTime: string | undefined;
    originalScheduledDropoffTime: string | undefined;
    brokerId: number | undefined;
    brokerContractId: string | undefined;
    brokerRideId: string | undefined;
    brokerComments: string | undefined;
    brokerRideReviewDate: Date | undefined;
    brokerLastUpdateDate: Date | undefined;
    brokerCancellationDate: Date | undefined;
    brokerBillingDate: Date | undefined;
    brokerBillingStatus: RideBrokerBillingStatus;
    rideDelegationPartnerId: number | undefined;
    delegatedRideId: string | undefined;
    delegatedRideStatus: string | undefined;
    paraScopeEvents: RideParaScopeEvents;
    paraScopeEventsPerformed: RideParaScopeEventFlags;
    nonPriorityTime: string | undefined;
    earliestPickupTime: string | undefined;
    latestPickupTime: string | undefined;
    earliestDropoffTime: string | undefined;
    latestDropoffTime: string | undefined;
    tripPortalResourceId: string | undefined;
    brokerContract: BrokerContract;
    billingZone: BillingZone;
    dropoffLocation: Location;
    fixedRide: FixedRide;
    pickupLocation: Location;
    provider: Provider;
    purpose: Purpose;
    rideAlertProvider: RideAlertProvider;
    rider: Rider;
    riderAccount: RiderAccount;
    trip: Trip;
    scheduleProfile: ScheduleProfile;
    rideCharges: RideCharge[] | undefined;
    reminderCalls: ReminderCall[] | undefined;
    reminderTextMessages: ReminderTextMessage[] | undefined;
    rideSpecialAssistances: RideSpecialAssistance[] | undefined;
    signatures: Signature[] | undefined;
    passTransactions: PassTransaction[] | undefined;
    snapshotHistory: RideSnapshotHistory[] | undefined;
    portalUserRideRequests: PortalUserRideRequest[] | undefined;
    ridePayments: RidePayment[] | undefined;
}

export enum RideAcceptanceStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export interface RideAlertProvider {
    rideAlertProviderId: number;
    name: string | undefined;
    callBackPhone: string | undefined;
    companyName: string | undefined;
    isDefault: boolean;
    onTheWayLeadMinutes: number;
    nightBeforeStartTime: TimeSpan;
    maxRetryCount: number;
    retryInterval: TimeSpan;
    onTheWayCallTemplate: string | undefined;
    nightBeforeCallTemplate: string | undefined;
    onTheWayTextTemplate: string | undefined;
    nightBeforeTextTemplate: string | undefined;
    combineReminders: boolean;
    nightBeforeCallIntroTemplate: string | undefined;
    nightBeforeCallRideTemplate: string | undefined;
    nightBeforeCallCloseTemplate: string | undefined;
    nightBeforeTextIntroTemplate: string | undefined;
    nightBeforeTextRideTemplate: string | undefined;
    nightBeforeTextCloseTemplate: string | undefined;
    dbstatus: number;
    callerIdIsVerified: boolean;
    enableOTWRemindersForPickupPriorities: boolean;
    fixedRides: FixedRide[] | undefined;
    riders: Rider[] | undefined;
    rides: Ride[] | undefined;
    accounts: Account[] | undefined;
    reminderTextMessages: ReminderTextMessage[] | undefined;
    reminderCallAttempts: ReminderCallAttempt[] | undefined;
}

export enum RideBrokerBillingStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface RideCharge {
    rideId: number;
    accountChargeId: number;
    accountCharge: AccountCharge;
    ride: Ride;
}

export interface RideCreateError {
    code: string | undefined;
    message: string | undefined;
    type: string | undefined;
    meta: { [key: string]: string; } | undefined;
}

export interface RideCreateResponse {
    isSuccessful: boolean;
    ride: CreateRideResponse;
    errors: RideCreateError[] | undefined;
}

export interface RideDetailsModel {
    driver: DriverModel;
    vehicle: VehicleModel;
    scheduledPickupTime: Date;
    ride: RideModel;
    fareAmount: number | undefined;
}

export interface RideList {
    requestedRides: RequestRideResponse[] | undefined;
    totalRecords: number;
    pageSize: number;
}

export interface RideMessage {
    message: string | undefined;
    rideResourceId: string | undefined;
}

export interface RideModel {
    transportationProviderId: string;
    vendorRiderId: string | undefined;
    riderName: string | undefined;
    portalUserId: string;
    reservationType: string | undefined;
    rideDate: Date | undefined;
    pickupTime: Date | undefined;
    dropoffTime: Date | undefined;
    rideStatusId: number;
    rideStatusMessage: string | undefined;
    rideId: string;
    pickupAddress: AddressModel;
    dropoffAddress: AddressModel;
    comments: string | undefined;
    rideRequirements: number[] | undefined;
    escorts: number;
    paymentMethodToken: string | undefined;
    paymentProviderId: number | undefined;
}

export enum RideParaScopeEventFlags {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
}

export interface RideParaScopeEvents {
    onTheWay: boolean;
    pickupArrive: boolean;
    pickupPerform: boolean;
    dropoffArrive: boolean;
    dropoffPerform: boolean;
    signature: boolean;
    noShow: boolean;
    cancel: boolean;
    paraScopeEventsPerformedAsLoaded: RideParaScopeEventFlags;
    paraScopeEventsPerformed: RideParaScopeEventFlags;
}

export interface RidePayment {
    ridePaymentId: number;
    rideId: number | undefined;
    paymentMethodId: number;
    status: string | undefined;
    preAuthTransactionDate: Date | undefined;
    preAuthTransactionId: string | undefined;
    chargeTransactionDate: Date | undefined;
    chargeTransactionId: string | undefined;
    voidTransactionDate: Date | undefined;
    amount: number | undefined;
    message: string | undefined;
    errorMessage: string | undefined;
    actorType: string | undefined;
    actorId: string | undefined;
    application: string | undefined;
    paymentMethod: RiderPaymentMethod;
    ride: Ride;
    ridePaymentTransactions: RidePaymentTransaction[] | undefined;
}

export interface RidePaymentRequest {
    rideFares: RideRequestFareRequest[] | undefined;
    transportationProviderResourceId: string;
    portalUserResourceId: string;
    paymentMethodToken: string | undefined;
    paymentProviderId: number;
}

export interface RidePaymentStatusChangedModel {
    status: string | undefined;
}

export interface RidePaymentTransaction {
    ridePaymentTransactionId: number;
    createdDate: Date;
    requestText: string | undefined;
    responseText: string | undefined;
    isSuccess: boolean;
    ridePaymentId: number | undefined;
    ridePayment: RidePayment;
}

export interface RideRequest {
    reservationType: string | undefined;
    rideDate: Date | undefined;
    pickupTime: Date | undefined;
    dropoffTime: Date | undefined;
    pickupAddress: AddressModel;
    dropoffAddress: AddressModel;
    comments: string | undefined;
    rideRequirements: number[] | undefined;
    escorts: number;
    purposeId: number | undefined;
}

export interface RideRequestDetails {
    rideRequestResponseCode: string | undefined;
    initialAcceptStatus: number | undefined;
    initialAcceptMessage: string | undefined;
    name: string | undefined;
    rideDetails: RideDetailsModel;
    reason: string | undefined;
    scheduledPickupTimeUTC: Date | undefined;
    fareAmount: number | undefined;
}

export interface RideRequestFareRequest {
    rideRequest: RideRequest;
    fareAmount: number | undefined;
}

export interface RideRequestFareResponse {
    rideRequest: RideRequest;
    fareAmount: number | undefined;
    distance: number | undefined;
    duration: TimeSpan;
}

export interface RideRequirementType {
    rideRequirementId: number;
    name: string | undefined;
    toolTip: string | undefined;
    icon: string | undefined;
}

export enum RideRequirementTypes {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface RideReservationType {
    rideReservationId: number;
    name: string | undefined;
    toolTip: string | undefined;
}

export interface RideResponse {
    rideId: string;
    priorityType: PriorityKind;
    priorityTime: string | undefined;
    pickupName: string | undefined;
    pickupAddress1: string | undefined;
    pickupAddress2: string | undefined;
    pickupCity: string | undefined;
    pickupState: string | undefined;
    pickupZipCode: string | undefined;
    dropoffName: string | undefined;
    dropoffAddress1: string | undefined;
    dropoffAddress2: string | undefined;
    dropoffCity: string | undefined;
    dropoffState: string | undefined;
    dropoffZipCode: string | undefined;
    scheduledPickupTime: string | undefined;
    scheduledDropoffTime: string | undefined;
    rideDate: string | undefined;
    rideDescription: string | undefined;
    cancelableUntil: Date | undefined;
    eta: Date | undefined;
    fareAmount: number | undefined;
}

export interface RideSnapshotHistory {
    rideSnapshotHistoryId: number;
    snapshotData: string | undefined;
    rideId: number;
    dateRecorded: Date | undefined;
    updateSourceId: number | undefined;
    updateContext: string | undefined;
    reviewDate: Date | undefined;
    reviewedByUser: string | undefined;
    ride: Ride;
}

export interface RideSpecialAssistance {
    rideId: number;
    specialAssistanceId: number;
    ride: Ride;
    specialAssistance: SpecialAssistance;
}

export interface RideStatusType {
    rideStatusId: number;
    name: string | undefined;
    toolTip: string | undefined;
    icon: string | undefined;
    iconColor: string | undefined;
}

export interface RideStatusUpdate {
    isAccepted: boolean;
    statusMessage: string | undefined;
}

export interface RideTripPurposes {
    id: number;
    description: string | undefined;
    isActive: boolean;
}

export interface Rider {
    riderId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    middleInitial: string | undefined;
    medicaidNumber: string | undefined;
    dob: Date | undefined;
    ssn: string | undefined;
    phone: string | undefined;
    gender: string | undefined;
    customerAssignedUniqueId: string | undefined;
    languageId: number | undefined;
    specialDirections: string | undefined;
    doctorName: string | undefined;
    doctorPhone: string | undefined;
    contactName: string | undefined;
    contactPhone: string | undefined;
    dateLastRode: Date | undefined;
    numChildren: number;
    wheelchairRequired: boolean;
    escortRequired: boolean;
    dbstatus: number;
    providerId: number | undefined;
    ivrNightBefore: boolean | undefined;
    ivrOnTheWay: boolean | undefined;
    preferTextMessage: boolean | undefined;
    ssne: string | undefined;
    incomeId: number | undefined;
    raceId: number | undefined;
    emailAddress: string | undefined;
    rideAlertProviderId: number | undefined;
    phone2: string | undefined;
    scheduleProfileId: number | undefined;
    liftRequired: boolean;
    stretcherRequired: boolean;
    riderImageId: string | undefined;
    homeLocationId: number;
    billingLocationId: number | undefined;
    doctorLocationId: number | undefined;
    contactLocationId: number | undefined;
    defaultTripNumber: number | undefined;
    assessmentDate: Date | undefined;
    notes: string | undefined;
    lcriderId: number | undefined;
    brokerId: number | undefined;
    brokerRiderId: string | undefined;
    scheduleProfile: ScheduleProfile;
    billingLocation: Location;
    contactLocation: Location;
    doctorLocation: Location;
    homeLocation: Location;
    provider: Provider;
    income: Income;
    language: Language;
    race: Race;
    rideAlertProvider: RideAlertProvider;
    tripPortalResourceId: string | undefined;
    tripPortalInvitationConfirmed: boolean;
    externalClientId: string | undefined;
    episodeNumber: number | undefined;
    brokerReferences: BrokerRider[] | undefined;
    companies: Company[] | undefined;
    fixedRides: FixedRide[] | undefined;
    riderAccounts: RiderAccount[] | undefined;
    riderSpecialAssistances: RiderSpecialAssistance[] | undefined;
    rides: Ride[] | undefined;
    passes: Pass[] | undefined;
    portalDelegateOrganizationRiders: PortalDelegateOrganizationRider[] | undefined;
    driversWithRiderExcluded: DriverExcludedRider[] | undefined;
}

export interface RiderAccount {
    riderAccountId: number;
    riderId: number;
    accountId: number;
    accountNumber: string | undefined;
    expirationDate: Date | undefined;
    monthlyRideCount: number | undefined;
    comments: string | undefined;
    dbstatus: number | undefined;
    isDefault: boolean;
    account: Account;
    rider: Rider;
    fixedRides: FixedRide[] | undefined;
    rides: Ride[] | undefined;
}

export interface RiderPaymentMethod {
    riderMethodPaymentId: number;
    providerId: number;
    riderId: number;
    token: string | undefined;
    status: string | undefined;
    message: string | undefined;
    dbStatus: boolean;
    dateCreated: Date;
    provider: PaymentProvider;
    ridePayments: RidePayment[] | undefined;
}

export interface RiderResponse {
    riderId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    middleInitial: string | undefined;
    primaryPhone: string | undefined;
    emailAddress: string | undefined;
    dateOfBirth: string | undefined;
    language: string | undefined;
    zipCode: string | undefined;
    canBookRide: boolean | undefined;
    canCancelRide: boolean | undefined;
}

export interface RiderSearchResponse {
    riders: RiderResponse[] | undefined;
    count: number;
}

export interface RiderSpecialAssistance {
    riderId: number;
    specialAssistanceId: number;
    rider: Rider;
    specialAssistance: SpecialAssistance;
}

export interface RiderType {
    id: number;
    description: string | undefined;
    defaultFare: number;
    isActive: boolean;
    isSystem: boolean;
    dbStatus: number;
    passes: Pass[] | undefined;
    passTypes: PassType[] | undefined;
    flagStopJobs: FlagStopJob[] | undefined;
    defaultRiderTypeForCompany: Company[] | undefined;
}

export interface ScheduleProfile {
    scheduleProfileId: number;
    name: string | undefined;
    isDefault: boolean;
    averageLoadMinutes: number;
    averageUnloadMinutes: number;
    additionalWheelchairLoadMinutes: number;
    additionalWheelchairUnloadMinutes: number;
    additionalStretcherLoadMinutes: number;
    additionalStretcherUnloadMinutes: number;
    earlyPickupFlexibilityMinutes: number;
    addDirectDriveToEarliestPickUp: boolean | undefined;
    earlyDropOffFlexibilityMinutes: number;
    minimumPickupWindowDurationMinutes: number | undefined;
    latePickupFlexibilityMinutes: number;
    lateDropOffFlexibilityMinutes: number;
    addDirectDriveToLatestDropoff: boolean | undefined;
    minimumDropoffWindowDurationMinutes: number | undefined;
    useRequestedPickupTimeWindow: boolean;
    earlyRequestedPickupTimeMinutes: number | undefined;
    lateRequestedPickupTimeMinutes: number | undefined;
    useRequestedDropoffTimeWindow: boolean;
    earlyRequestedDropoffTimeMinutes: number | undefined;
    lateRequestedDropoffTimeMinutes: number | undefined;
    dbstatus: number;
    ride: Ride[] | undefined;
    rider: Rider[] | undefined;
    accounts: Account[] | undefined;
}

export interface Service {
    serviceId: number;
    serviceCategoryId: number;
    name: string | undefined;
    estimatedCost: number | undefined;
    intervalDays: number | undefined;
    intervalMiles: number | undefined;
    isActive: boolean;
    serviceCategory: ServiceCategory;
    approvedVendors: ApprovedVendor[] | undefined;
    serviceRequests: ServiceRequest[] | undefined;
    serviceSchedules: ServiceSchedule[] | undefined;
}

export interface ServiceCategory {
    serviceCategoryId: number;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    services: Service[] | undefined;
    inspectionItems: InspectionItem[] | undefined;
}

export interface ServiceRequest {
    serviceRequestId: number;
    serviceId: number;
    vehicleId: number;
    vendorId: number | undefined;
    vendorQuotedCosts: number | undefined;
    requestedDate: Date;
    dueDate: Date | undefined;
    dueOdometer: number | undefined;
    status: ServiceRequestStatus;
    odometerCompleted: number | undefined;
    dateCompleted: Date | undefined;
    actualCosts: number | undefined;
    comments: string | undefined;
    service: Service;
    vehicle: Vehicle;
    vendor: Vendor;
}

export enum ServiceRequestStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface ServiceSchedule {
    id: number;
    maintenancePlanId: number;
    serviceId: number;
    intervalDays: number | undefined;
    intervalMiles: number | undefined;
    maintenancePlan: MaintenancePlan;
    service: Service;
}

export interface Signature {
    signatureId: number;
    rideId: number;
    signatureValue: string | undefined;
    signatureValueReduced: string | undefined;
    reason: string | undefined;
    ride: Ride;
}

export interface SpecialAssistance {
    specialAssistanceId: number;
    code: string | undefined;
    description: string | undefined;
    disability: boolean;
    fixed: boolean;
    dbstatus: number;
    additionalLoadMinutes: number;
    additionalUnloadMinutes: number;
    requiresVehicle: boolean;
    requiresDriver: boolean;
    driverSpecialAssistances: DriverSpecialAssistance[] | undefined;
    fixedRideSpecialAssistances: FixedRideSpecialAssistance[] | undefined;
    rideSpecialAssistances: RideSpecialAssistance[] | undefined;
    riderSpecialAssistances: RiderSpecialAssistance[] | undefined;
    vehicleSpecialAssistances: VehicleSpecialAssistance[] | undefined;
}

export enum SubscriptionRecurType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export interface TimeSpan {
    ticks: number;
    readonly days: number;
    readonly hours: number;
    readonly milliseconds: number;
    readonly minutes: number;
    readonly seconds: number;
    readonly totalDays: number;
    readonly totalHours: number;
    readonly totalMilliseconds: number;
    readonly totalMinutes: number;
    readonly totalSeconds: number;
}

export interface TransportationProviderModel {
    transportationProviderId: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    logoImgUrl: string | undefined;
    webPaymentToken: string | undefined;
    defaultLatitude: number | undefined;
    defaultLongitude: number | undefined;
    brandId: string | undefined;
}

export interface TransportationProviderSettingsProviderRequest {
    transportationProviderId: string | undefined;
    companyName: string | undefined;
    companyNumber: string | undefined;
    externalId: string | undefined;
    active: boolean;
    minMinutesBeforeRide: number | undefined;
    maxDaysBeforeRide: number | undefined;
    providerKey: string | undefined;
    vendorId: string | undefined;
}

export interface TransportationProviderSettingsProviderResponse {
    transportationProviderId: string;
    companyName: string | undefined;
    companyNumber: string | undefined;
    enabledProviderKeys: string[] | undefined;
    active: boolean;
    minMinutesBeforeRide: number | undefined;
    maxDaysBeforeRide: number | undefined;
}

export interface TransportationProviderSettingsRequest {
    transportationProviderId: string;
    companyName: string | undefined;
    companyNumber: string | undefined;
    active: boolean;
    minMinutesBeforeRide: number | undefined;
    maxDaysBeforeRide: number | undefined;
}

export interface TransportationProviderSettingsResponse {
    transportationProviderId: string;
    companyName: string | undefined;
    companyNumber: string | undefined;
    active: boolean;
    canBookRide: boolean;
    canCancelRide: boolean;
    minMinutesBeforeRide: number | undefined;
    maxDaysBeforeRide: number | undefined;
    outOfServiceDates: OutOfServiceRange[] | undefined;
}

export interface Trip {
    tripId: number;
    description: string | undefined;
    vehicleId: number | undefined;
    driverId: number | undefined;
    fixedTripId: number | undefined;
    number: number | undefined;
    status: number | undefined;
    tripDate: Date | undefined;
    remarks: string | undefined;
    scheduledStartTime: string | undefined;
    scheduledEndTime: string | undefined;
    actualStartTime: string | undefined;
    actualEndTime: string | undefined;
    startWaitTime: string | undefined;
    endWaitTime: string | undefined;
    startOdometer: number | undefined;
    endOdometer: number | undefined;
    purposeId: number | undefined;
    traineeId: number | undefined;
    escortId: number | undefined;
    firstPickupTime: string | undefined;
    firstPickupOdometer: number | undefined;
    lastDropOffTime: string | undefined;
    lastDropOffOdometer: number | undefined;
    gasolineGallons: number | undefined;
    gasolineCost: number | undefined;
    gasolineOdometer: number | undefined;
    oil: boolean | undefined;
    accidentRemarks: string | undefined;
    accidentOdometer: number | undefined;
    breakDownRemarks: string | undefined;
    breakDownOdometer: number | undefined;
    traineeStartTime: string | undefined;
    traineeEndTime: string | undefined;
    escortStartTime: string | undefined;
    escortEndTime: string | undefined;
    transmissionFluid: boolean | undefined;
    brakeFluid: boolean | undefined;
    coolant: boolean | undefined;
    powerSteeringFluid: boolean | undefined;
    accident: boolean | undefined;
    breakdown: boolean | undefined;
    dbstatus: number | undefined;
    excludeFromAutoschedule: boolean | undefined;
    locked: boolean | undefined;
    includePreTrip: boolean | undefined;
    includePostTrip: boolean | undefined;
    includeBreak: boolean | undefined;
    preTripDuration: number | undefined;
    preTripActualStartTime: string | undefined;
    preTripActualEndTime: string | undefined;
    preTripStartOdometer: number | undefined;
    preTripEndOdometer: number | undefined;
    postTripDuration: number | undefined;
    postTripActualStartTime: string | undefined;
    postTripActualEndTime: string | undefined;
    postTripStartOdometer: number | undefined;
    postTripEndOdometer: number | undefined;
    breakScheduledStartTime: string | undefined;
    breakDuration: number | undefined;
    breakActualStartTime: string | undefined;
    breakActualEndTime: string | undefined;
    breakStartOdometer: number | undefined;
    breakEndOdometer: number | undefined;
    breakWindowOpen: string | undefined;
    breakWindowClose: string | undefined;
    providerId: number | undefined;
    actualEndDateTime: Date | undefined;
    actualStartDateTime: Date | undefined;
    overnight: number | undefined;
    rideAlertStyle: string | undefined;
    ivrnightBefore: boolean | undefined;
    ivronTheWay: boolean | undefined;
    blackoutStartTime: string | undefined;
    includeBlackout: boolean;
    blackoutDuration: number;
    icb: boolean;
    availableStartTime: string | undefined;
    availableEndTime: string | undefined;
    driverSignature: string | undefined;
    rural: boolean | undefined;
    demandResponse: boolean | undefined;
    directlyOperated: boolean | undefined;
    startDepotLocationId: number | undefined;
    endDepotLocationId: number | undefined;
    enableFlagStops: boolean;
    driverSignatureReduced: string | undefined;
    gtfsBlockId: number | undefined;
    allowMicrotransitRides: boolean;
    maxAllowableHours: string | undefined;
    driver: Driver;
    endDepotLocation: Location;
    escort: Driver;
    fixedTrip: FixedTrip;
    provider: Provider;
    purpose: Purpose;
    startDepotLocation: Location;
    trainee: Driver;
    vehicle: Vehicle;
    flagStopBlockRoute: GtfsBlock;
    tripSchedule: TripSchedule;
    tripInspections: Inspection[] | undefined;
    rides: Ride[] | undefined;
    gpsReports: GpsReport[] | undefined;
    driverSessions: DriverSession[] | undefined;
    performedFlagStops: PerformedFlagStop[] | undefined;
    vehicleCurrentStatuses: VehicleCurrentStatus[] | undefined;
    tripOverlays: TripOverlays[] | undefined;
}

export interface TripOverlays {
    tripOverlayId: number;
    tripId: number;
    mapOverlayId: number;
    startTime: string | undefined;
    endTime: string | undefined;
    trip: Trip;
    mapOverlay: MapOverlay;
}

export interface TripPortalSettings {
    companyName: string;
    phoneNumber: string;
    companyLogoUrl: string | undefined;
    defaultAccountId: number | undefined;
    defaultAccountDisplayValue: string | undefined;
    defaultAccountDisplayName: string | undefined;
    allowCancellations: boolean;
    allowRideRequestsFromSelfRegisteredRiders: boolean;
    denyBasedOnMinDaysBeforeRideDate: number | undefined;
    maximumNumberOfDaysInTheFuture: number | undefined;
    denyBasedOnOutOfServiceDate: boolean;
    denyBasedOnRouteAvailability: boolean;
    acceptBasedOnScheduling: boolean;
    denyBasedOnScheduling: boolean;
    minimumNumberOfHoursBeforePriorityTime: number | undefined;
    denyIfRiderIsInactive: boolean;
    denyIfRideIsSoonerThanPriorityTimeMinimumHours: boolean;
    allowRiderToPayForRides: boolean;
    requirePaymentForRide: boolean;
    allowRiderToPutMoneyOnPasses: boolean;
    denyIfRideIsTooFarInTheFuture: boolean;
    transportationProviderResourceId: string;
    outOfServiceDates: string[] | undefined;
    paymentProvider: PaymentProviderSettings;
    usePortalSettingsForDelegates: boolean;
}

export interface TripSchedule {
    tripId: number;
    createdDate: Date;
    scheduleJson: string | undefined;
    trip: Trip;
}

export interface UserChangePasswordModel {
    password: string;
    confirmPassword: string | undefined;
}

export interface UserLoginModel {
    email: string;
    password: string;
}

export interface UserProfile {
    firstName: string | undefined;
    middleInitial: string | undefined;
    lastName: string | undefined;
    genderId: number | undefined;
    genderDescription: string | undefined;
    dateOfBirth: string | undefined;
    phoneNumber: string | undefined;
    address: AddressModel;
    rideRequirements: RideRequirementTypes[] | undefined;
    prefersTextMessage: boolean;
    emailAddress: string | undefined;
    isDelegateUser: boolean;
    portalUserId: string;
    comments: string | undefined;
    transportationProvider: TransportationProviderModel;
    transportationProviders: TransportationProviderModel[] | undefined;
    vendorTransportationProviders: VendorDelegateTransportationProvider[] | undefined;
}

export interface UserRegistrationModel {
    email: string;
    password: string;
    confirmPassword: string | undefined;
    userProfile: NewUserProfile;
}

export interface Vehicle {
    vehicleId: number;
    number: string | undefined;
    make: string | undefined;
    year: string | undefined;
    typeId: number | undefined;
    capacity: number | undefined;
    maximumGallons: number | undefined;
    maxQuartsOil: number | undefined;
    tireSize: number | undefined;
    licensePlate: string | undefined;
    licensePlateState: string | undefined;
    vin: string | undefined;
    countyCode: string | undefined;
    fuelType: number | undefined;
    owner: string | undefined;
    purchaseDate: Date | undefined;
    purchaseOdometer: number | undefined;
    purchasePrice: number | undefined;
    wheelChairCapacity: number | undefined;
    wheelChairFlag: boolean | undefined;
    radioFlag: boolean | undefined;
    disposalFlag: boolean | undefined;
    disposedDate: Date | undefined;
    vechicleStatus: number | undefined;
    lastServiceOdometer: number | undefined;
    lastServiceDate: Date | undefined;
    nextServiceOdometer: number | undefined;
    servicePlanId: number | undefined;
    dbstatus: number | undefined;
    autoscheduleActive: boolean | undefined;
    loggedOn: boolean | undefined;
    flipSeatsPerWc: number | undefined;
    currentDriverId: number | undefined;
    mdtenabled: boolean;
    status: number;
    boardingPreperationDuration: TimeSpan;
    stretcherCapacity: number | undefined;
    liftFlag: boolean | undefined;
    maintenancePlanId: number | undefined;
    garageLocationId: number | undefined;
    lcvehicleId: number | undefined;
    latitude_DEPRECATED: number | undefined;
    longitude_DEPRECATED: number | undefined;
    lastGpsreport_DEPRECATED: Date | undefined;
    speed_DEPRECATED: number | undefined;
    currentDriver: Driver;
    garageLocation: Location;
    type: VehicleType;
    currentStatus: VehicleCurrentStatus;
    brokerReferences: BrokerVehicle[] | undefined;
    tripInspections: Inspection[] | undefined;
    fixedTrips: FixedTrip[] | undefined;
    trips: Trip[] | undefined;
    vehicleSpecialAssistances: VehicleSpecialAssistance[] | undefined;
    gpsReports: GpsReport[] | undefined;
    dispatchMessages: DispatchMessage[] | undefined;
    serviceRequests: ServiceRequest[] | undefined;
    outOfServicePeriods: OutOfServicePeriod[] | undefined;
}

export interface VehicleCurrentStatus {
    vehicleId: number;
    tripId: number | undefined;
    gpsReportId: number | undefined;
    dateTimeRecorded: Date | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    speed: number | undefined;
    odometer: number | undefined;
    vehicle: Vehicle;
    trip: Trip;
}

export interface VehicleModel {
    make: string | undefined;
    model: string | undefined;
    color: string | undefined;
    number: string | undefined;
}

export interface VehicleSpecialAssistance {
    vehicleId: number;
    specialAssistanceId: number;
    specialAssistance: SpecialAssistance;
    vehicle: Vehicle;
}

export interface VehicleType {
    vehicleTypeId: number;
    description: string | undefined;
    rate: number;
    dbstatus: number;
    vehicles: Vehicle[] | undefined;
}

export interface Vendor {
    vendorId: number;
    name: string | undefined;
    contactName: string | undefined;
    phone: string | undefined;
    address: string | undefined;
    isActive: boolean;
    approvedVendors: ApprovedVendor[] | undefined;
    serviceRequests: ServiceRequest[] | undefined;
}

export interface VendorAddressModel {
    name: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    county: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    locationPhone: string | undefined;
    phoneExt: string | undefined;
}

export interface VendorApiResponse {
    success: boolean;
    responseMessage: string | undefined;
    subjectResourceId: string | undefined;
}

export interface VendorDelegateOrg {
    delegateOrgName: string | undefined;
    delegateOrgResourceId: string | undefined;
}

export interface VendorDelegateOrganization {
    companyName: string | undefined;
    phone: string | undefined;
    logoImageUrl: string | undefined;
    isDisabled: boolean;
    transportationProviderResourceId: string | undefined;
}

export interface VendorDelegateRideRequest {
    rideRequestDate: Date;
    firstName: string | undefined;
    lastName: string | undefined;
    medicaidNumber: string | undefined;
    ssn: string | undefined;
    contactPhone: string | undefined;
    contactPhoneExt: string | undefined;
    dateOfBirth: Date | undefined;
    genderId: number | undefined;
    genderDescription: string | undefined;
    contactEmail: string | undefined;
    isSelfRegisteredUser: boolean;
    dropOffDateTime: Date | undefined;
    pickupDateTime: Date | undefined;
    tripPortalRiderResourceId: string | undefined;
    tripPortalRideRequestResourceId: string;
    tripPortalDelegateOrganizationResourceId: string;
    fromAddress: VendorAddressModel;
    rideStatus: RideAcceptanceStatus;
    toAddress: VendorAddressModel;
    comments: string | undefined;
    declineMessage: string | undefined;
    liftRequired: boolean;
    wheelChairRequired: boolean;
    stretcherRequired: boolean;
    numberOfChildren: number;
    numberOfEscorts: number;
    dateCreatedUTC: Date;
    prefersTextMessage: boolean;
    paymentMethodToken: string | undefined;
    paymentProviderId: number | undefined;
    fareAmount: number | undefined;
    vendorRiderId: string | undefined;
    tripPortalDelegateResourceId: string | undefined;
    organizationName: string | undefined;
    delegateFirstName: string | undefined;
    delegateLastName: string | undefined;
    delegateNewRiderComments: string | undefined;
    purposeId: number | undefined;
}

export interface VendorDelegateRider {
    firstName: string | undefined;
    lastName: string | undefined;
    middleInitial: string | undefined;
    specialDirections: string | undefined;
    vendorRiderId: string | undefined;
    transportationProviderId: string | undefined;
}

export interface VendorDelegateTransportationProvider {
    tpName: string | undefined;
    tpResourceId: string | undefined;
    organizations: VendorDelegateOrg[] | undefined;
}

export interface VendorDelegateUser {
    delegateUserEmail: string | undefined;
    nameFirst: string | undefined;
    nameLast: string | undefined;
    isDisabled: boolean;
}

export interface VendorPortalUser {
    nameFirst: string | undefined;
    nameLast: string | undefined;
    userEmail: string | undefined;
    contactPhone: string | undefined;
    isDisabled: boolean;
}

export interface VendorPortalUserSummary {
    isDelegateUser: boolean;
    portalUserFirstName: string | undefined;
    portalUserLastName: string | undefined;
    portalUserRegistrationStatus: PortalUserRegistrationStatusEnum;
    isAccountActive: boolean;
}

export interface VendorTransportationProvider {
    companyName: string | undefined;
    phone: string | undefined;
    logoImageUrl: string | undefined;
    timeZone: string | undefined;
    transportationProviderResourceId: string | undefined;
    isDisabled: boolean;
}

export interface VerifyPaymentMethodTokenModel {
    transportationProviderId: string | undefined;
    paymentToken: string | undefined;
    paymentProviderId: number;
}

export interface VerifyResponseModel {
    readonly paymentTokenIsValid: boolean;
    readonly invalidReason: string | undefined;
    resourceId: string | undefined;
}

export interface VoiceAgentVendorRideRequest {
    requestId: string;
    priorityType: string | undefined;
    priorityTime: Date | undefined;
    pickupName: string | undefined;
    pickupAddress1: string | undefined;
    pickupAddress2: string | undefined;
    pickupCity: string | undefined;
    pickupState: string | undefined;
    pickupZipCode: string | undefined;
    dropoffName: string | undefined;
    dropoffAddress1: string | undefined;
    dropoffAddress2: string | undefined;
    dropoffCity: string | undefined;
    dropoffState: string | undefined;
    dropoffZipCode: string | undefined;
    scheduledPickupTime: Date | undefined;
    scheduledDropoffTime: Date | undefined;
    rideDate: Date;
    rideDescription: string | undefined;
    fareAmount: number | undefined;
    cancellableUntil: Date | undefined;
}

export interface WillCallReadyResponse {
    success: boolean;
    message: string | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}